import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AlertService, AuthenticationService, ConstantService, UserService } from '@app/_services';
import { Router, ActivatedRoute } from '@angular/router';
import { NoteService } from '@app/_components/task/note';
// removed duplicate AlertService import
import { ConfirmationService, MessageService } from 'primeng/api';
import { ReservationService } from '../..';
import { first, take } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WorkOrderComponent } from './work-order/work-order.component';
import { WorkOrder } from './work-order/work-order';
import { LostFoundService } from '@app/_components/lost-found/lost-found.service';
import { FormArray, FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import * as moment from "moment";
import { Calendar } from 'primeng/calendar';
import { ChangeDetectorRef } from '@angular/core';
import { AdditionalPaymentComponent } from './additional-payment/additional-payment.component';
import { ReconcileCapturedPopupComponent } from './reconcile-captured-popup/reconcile-captured-popup.component';
import { NotesChatConfig } from '../../../../_components/_shared/notes-chat/notes-chat.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TooltipModule } from 'primeng/tooltip';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
const numberFormatter = new Intl.NumberFormat('en-US', {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
});

@Component({
    selector: 'app-reservation',
    templateUrl: './reservation.component.html',
    styleUrls: ['./reservation.component.css'],
    providers: [
        MessageService,
        ConfirmationService,
    ],
    standalone: false
})
export class ReservationComponent implements OnInit {

	@ViewChild('checkInDateCal') public checkInDateCalender: Calendar;
	@ViewChild('checkOutDateCal') public checkOutDateCalender: Calendar;

	updatedCheckInDate: Date;
	checkOutDateBasedOnCheckinDate: Date;
	isDateLessThanCheckinDate = false;
	isDisplayClearDates = false;
	minDate: Date;
	maxDate: Date;

	// form
	formLoading = false;

	// nav
	tabIndex: number;
	numAdults: any[];
	workOrders: any;
	lostFounds: any;

	// forms
	form1: UntypedFormGroup;
	form2: UntypedFormGroup;
	formAlert: String;
	formTitle: String;

	// Notes Configuration
	isLoadingNotes: boolean = false;
	isNoteSaving: unknown = false;
	notesChatConfig: NotesChatConfig = {
		title: 'Reservation Notes',
		maxWidth: '100%',
		maxHeight: '250px',
		customClass: '',
		fieldsPosition: 'top',
		fillParent: false,
		showFilters: true,
		showSortOptions: false,
		sortByDate: 'desc',
		allowEdit: true,
		allowDelete: false,
		allowAdd: true,
		emptyNotesText: 'No notes added',
		placeholder: 'Enter remarks',
		theme: 'default',
		maxNoteLength: 150,
		editButtonText: 'Edit Note',
		deleteButtonText: 'Delete Note',
		cancelButtonText: 'Cancel',
		noteTypes: [
			{ value: 1, name: 'General', color: '#DCDCDC' },
			{ value: 2, name: 'Action Item', color: '#ffcccc' },
			{ value: 4, name: 'Meeting Notes', color: '#ade061' },
			{ value: 5, name: 'Status Update', color: '#FFFF99' }
		],
		statusOptions: [
			{ value: 0, name: 'Open', color: '#D3D3D3' },
			{ value: 1, name: 'Complete', color: '#90EE90' },
			{ value: 2, name: 'Proposed', color: '#FFE599' },
			{ value: 3, name: 'On Hold', color: '#ADD8E6' },
			{ value: 4, name: 'Cancelled', color: '#F4A6A6' },
			{ value: 5, name: 'In Progress', color: '#FFA500' }
		]
	};

	loading: boolean = false;


	@Input() reservation: any;
	@Input() order: any;
	@Input() paymentSources: any;
	@Input() reservationCount: any;
	@Input() reservationIndex: any;
	@Output() getReservations = new EventEmitter<any>();
	@Output() refreshOrder = new EventEmitter<any>();
	referralSources: any[];
	payEnum: any[];
	reservationStatuses: any[] = [];
	orderStatuses: any[];
	hours: any[];
	minutes: any[];
	amPm: any[];
	airlines: any[];
	countries: any;
	states: any;
	reservationId: any;
	travelOcassions: any;
	cardExpiryMonths: any[];
	cardExpiryYears: any[];
	paymentTypes: any[];
	keyServiceCheckIn: any[];
	orderDetails: any[];
	totalAmounts: number;
	totalTaxes: number;
	grandTotals: number;
	salesManList: any[];
	visible = false;
	isGuestAgreeForCreditCard = false;
	disabledBookReservationButton = false;
	showPaymentSuccess = false;
	hardDeleting = false;
	hardDeleteResult: any = null;
	showHardDeleteResult = false;
	hardDeletePasswordDialogVisible = false;
	hardDeletePasswordValue = '';
	hardDeletePasswordError = '';
	pendingHardDeleteOrderId: number | null = null;

	cardExpirationMonthMessage: string = "Expiration cannot be in the past";
	travelInsuranceMsg: string = "Travel insurance selection is required";
	guestContractApproveMsg: string = "Acknowledgement is required. Questions? Call (800) 768-6994";
	firstNameMsg: string = "Full name is required";
	lastNameMsg: string = "Last name is required";
	emailAddressMsg: string = "Email address is required";
	validEmailAddressMsg: string = "Valid email is required";
	mobilePhoneMsg: string = "Mobile number is required";
	adrStreetMsg: string = "Address is required";
	adrCitytMsg: string = "City is required";
	adrStateMsg: string = "State or Province is required";
	adrPostalCodeMsg: string = "Postal Code is required";
	adrCountryMsg: string = "Country is required";
	cardHolderNameMsg: string = "Cardholder name is required";
	paymentAddressMsg: string = "Address is required";
	paymentCityMsg: string = "City is required";
	paymentStateMsg: string = "State is required";
	paymentPostalMsg: string = "Postal Code is required";
	paymentProcessAmountMsg: string = "Payment amount is required";
	expirationMonthMsg: string = "Month is required";
	expirationYearMsg: string = "Year is required";
	creditCardNumberMsg: string = "Card number is required";
	cvvCodeMsg: string = "CCV code is required";
	year: number;
	years: any[] = [];
	paymentCreditCardRequests: any[];
	isLoadData = false;
	housekeepingTypes: any[];
	workOrderStatuses: any[];
	childrens: any[];
	checkInMinDate: Date;
	checkOutMinDate: Date;
	checkInMaxDate: Date;
	checkOutMaxDate: Date;
	colorName: string;
	location: any;
	rateLogOutput;
	rateLosLogOutput;
	listingTypes: { value: number; name: string; }[];
	reservationTypes: any[];
	constructor(
		private lostFoundService: LostFoundService,
		public alertService: AlertService,
		private location1: Location,
		private authenticationService: AuthenticationService,
		private userService: UserService,
		private reservationService: ReservationService,
		private confirmationService: ConfirmationService,
		private router: Router,
		private constantService: ConstantService,
		private formBuilder: UntypedFormBuilder,
		private messageService: MessageService,
		private dialog: MatDialog,
		private cdr: ChangeDetectorRef,
		private activatedRoute: ActivatedRoute,
		private noteService: NoteService) {
		this.numAdults = this.reservationService.numAdults;
		this.childrens = this.reservationService.children;
		this.referralSources = this.reservationService.referralSources;
		this.reservationStatuses = this.reservationService.reservationStatuses;
		this.payEnum = this.reservationService.payEnum;
		this.paymentCreditCardRequests = this.reservationService.paymentCreditCardRequests;
		this.orderStatuses = this.reservationService.orderStatuses;
		this.hours = this.reservationService.hours;
		this.minutes = this.reservationService.minutes;
		this.amPm = this.reservationService.amPm;
		this.airlines = this.reservationService.airlines;
		this.countries = this.constantService.countries;
		this.states = this.constantService.states;
		this.travelOcassions = this.reservationService.travelOcassions;
		this.cardExpiryMonths = this.reservationService.cardExpiryMonths;
		this.cardExpiryYears = this.reservationService.cardExpiryYears;
		this.paymentTypes = this.reservationService.paymentTypes;
		this.keyServiceCheckIn = this.reservationService.keyServiceCheckIn;
		this.salesManList = this.reservationService.salesManList;
		this.housekeepingTypes = this.reservationService.housekeepingTypes;
		this.workOrderStatuses = this.reservationService.workOrderStatuses;
		this.listingTypes = this.reservationService.listingTypes;
		this.reservationTypes = this.reservationService.reservationTypes;
	}

	adults = [
		{ name: 'Adults', value: "" },
		{ name: '1', value: 1 },
		{ name: '2', value: 2 },
		{ name: '3', value: 3 },
		{ name: '4', value: 4 },
		{ name: '5', value: 5 },
		{ name: '6', value: 6 },
		{ name: '7', value: 7 },
		{ name: '8', value: 8 },
		{ name: '9', value: 9 },
		{ name: '10', value: 10 },
		{ name: '11', value: 11 },
		{ name: '12', value: 12 },
		{ name: '13', value: 13 },
		{ name: '14', value: 14 },
		{ name: '15', value: 15 },
		{ name: '16', value: 16 },
		{ name: '17', value: 17 },
		{ name: '18', value: 18 },
		{ name: '19', value: 19 },
		{ name: '20', value: 20 },
	];

	children = [
		{ name: 'Children', value: "" },
		{ name: '0', value: 0 },
		{ name: '1', value: 1 },
		{ name: '2', value: 2 },
		{ name: '3', value: 3 },
		{ name: '4', value: 4 },
		{ name: '5', value: 5 },
		{ name: '6', value: 6 },
		{ name: '7', value: 7 },
		{ name: '8', value: 8 },
		{ name: '9', value: 9 },
		{ name: '10', value: 10 },
		{ name: '11', value: 11 },
		{ name: '12', value: 12 },
		{ name: '13', value: 13 },
		{ name: '14', value: 14 },
		{ name: '15', value: 15 },
		{ name: '16', value: 16 },
		{ name: '17', value: 17 },
		{ name: '18', value: 18 },
		{ name: '19', value: 19 },
		{ name: '20', value: 20 },
	];

	months = [
		{ value: '01', name: 'January' },
		{ value: '02', name: 'February' },
		{ value: '03', name: 'March' },
		{ value: '04', name: 'April' },
		{ value: '05', name: 'May' },
		{ value: '06', name: 'June' },
		{ value: '07', name: 'July' },
		{ value: '08', name: 'August' },
		{ value: '09', name: 'September' },
		{ value: '10', name: 'October' },
		{ value: '11', name: 'November' },
		{ value: '12', name: 'December' }
	];

	validationMessages = {
		emailAddress: [],
		status: [],
		referralSourceId: [],
		creditSaleToUserId: [],
		creditSaleToUser2Id: [],
		salesTax: [],
		tax: [],
		premium: [],
		reservationStatus: [],
		holdExpirationDate: [],
		numAdults: [],
		numChildren: [],
		primaryMobilePhone: [],
		specialRequests: [],
		airportArrivalDate: [],
		airportDepartureDate: [],
		propertyArrivalDate: [],
		propertyDepartureDate: [],
		arrivalHour1: [],
		arrivalMinute1: [],
		arrivalAmPm1: [],
		arrivingAirlineName: [],
		arrivingAirlineFlightNum: [],
		arrivalHour2: [],
		arrivalMinute2: [],
		arrivalAmPm2: [],
		departingAirlineName: [],
		departingAirlineFlightNum: [],
		propertyArrivalHour1: [],
		propertyArrivalMinute1: [],
		propertyArrivalAmPm1: [],
		propertyArrivalHour2: [],
		propertyArrivalMinute2: [],
		propertyArrivalAmPm2: [],
		checkOutDate: [],
		checkInDate: [],
		guestNotes: [],
		opsNotes: [],
		lostFoundId: [],
		keyServiceType: [],
		emergencyContactNotes: [],
		travelOccasionNotes: [],
		travelOccasion: [],
		earlyCheckinDate: [],
		lateCheckoutDate: [],
		codeFrontDoor: [],
		codeGarage: [],
		towelCode: [],
		codeGate: [],
		codeHoaGate: [],
		rentalCarBudget: [],
		rentalCarAvis: [],
		codePool: [],
		codeRecreation: [],
		ruReservationId: [],
		listingType: [],
		reservationType: [],


		firstName: [{ type: 'required', message: 'Required' }],
		lastName: [{ type: 'required', message: 'Required' }],
		title: [''],
		mobilePhone: [{ type: 'required', message: 'Required' }],
		adrStreet: [{ type: 'required', message: 'Required' }],
		adrCity: [{ type: 'required', message: 'Required' }],
		adrState: [{ type: 'required', message: 'Required' }],
		adrPostalCode: [{ type: 'required', message: 'Required' }],
		adrCountry: [{ type: 'required', message: 'Required' }],
		adrPhone: [{ type: 'required', message: 'Required' }],

		billingName: [{ type: 'required', message: 'Required' }],
		billingStreetAddress: [{ type: 'required', message: 'Required' }],
		billingCity: [{ type: 'required', message: 'Required' }],
		billingState: [{ type: 'required', message: 'Required' }],
		billingPostalCode: [{ type: 'required', message: 'Required' }],
		billingCountry: [{ type: 'required', message: 'Required' }],
		creditCardNumber: [{ type: 'required', message: 'Required' }],
		creditCardExpirationMonth: [{ type: 'required', message: 'Required' }],
		creditCardExpirationYear: [{ type: 'required', message: 'Required' }],
		creditCardSecurityCode: [{ type: 'required', message: 'Required' }],
		paymentType: [],
		achBankName: [],
		achBankAccountNumber: [],
		achRoutingNumber: [],
		achCheckNumber: [],
		achMicrData: [],
		achBranchSortCode: [],

	};

	validationMessages1 = {
		city: [
			{ type: 'required', message: this.paymentCityMsg }],
		stateOrProvince: [
			{ type: 'required', message: this.paymentStateMsg }],
		postalCode: [
			{ type: 'required', message: this.paymentPostalMsg }],
		paymentAmount: [
			{ type: 'required', message: this.paymentProcessAmountMsg }],
		country: [
			{ type: 'required', message: 'Country is required.' }],
		cardName: [
			{ type: 'required', message: this.cardHolderNameMsg }],
		cardExpirationMonth: [
			{ type: 'required', message: this.expirationMonthMsg }],
		cardExpirationYear: [
			{ type: 'required', message: this.expirationYearMsg }],
		cardNumber: [
			{ type: 'required', message: this.creditCardNumberMsg },
			{ type: 'maxlength', message: '19 characters maximum' },
			{ type: 'minlength', message: '15 characters minimum' }],
		cardSecurityCode: [
			{ type: 'required', message: this.cvvCodeMsg },
			{ type: 'maxlength', message: '3 characters maximum' },
			{ type: 'minlength', message: '4 characters minimum' }],
		cardType: [],
		signName: [
			{ type: 'required', message: 'Enter firstname and lastname is required.' }],
		signEmail: [
			{ type: 'required', message: 'Enter email address.' }],
		iAgree: [{ type: 'required', message: "required" }],
		paymentSourceId: [],
		paymentCreditCardRequestedTransactionType: []
	};

	ngOnInit(): void {
		let today = new Date();
		let month = today.getMonth();
		let year = today.getFullYear();
		let day = today.getDate();
		this.updatedCheckInDate = today;
		this.minDate = new Date();
		this.maxDate = new Date(year + 3, month, day);
		// this.formBuild();
		this.year = new Date().getFullYear();
		for (let i = 0; i < 10; i++) {
			this.years.push({ name: this.year.toString(), value: this.year.toString() });
			this.year = this.year + 1;
		}
		// resolver data
		if (this.reservation == null && this.reservation == undefined) {
			this.activatedRoute.params.subscribe(params => {
				this.reservationId = params.reservationId; // (+) converts string 'id' to a number
			});
			if (this.reservationId != null && this.reservationId != undefined) {
				this.findReservationById();
			} else {
				this.formBuild();
			}
		} else {
			this.reservationId = this.reservation?.reservationId;
			if (this.reservationId != null && this.reservationId != undefined) {
				this.findReservationById();
			}
		}
		console.log("this.reservation : " + JSON.stringify(this.reservation))
	}

	// book reservation form builder
	// formBuildForCreditCard() {
	// 	this.form2 = this.formBuilder.group({
	// 		//passed from quote
	// 		reservationId: [this.reservation?.reservationId],
	// 		orderId: [this.reservation?.order?.orderId],

	// 		paymentSource: this.formBuilder.group({
	// 			cardName: [this.reservation?.guestProfile?.firstName+" "+this.reservation?.guestProfile?.lastName, Validators.required],
	// 			cardExpirationMonth: ['', Validators.required],
	// 			cardExpirationYear: ['', Validators.required],
	// 			cardNumber: ['', Validators.required],
	// 			cardSecurityCode: new FormControl('', [Validators.required]),
	// 			cardType: [],
	// 			addressLine1: [],
	// 			city: [],
	// 			stateOrProvince: [],
	// 			postalCode: ['', Validators.required],
	// 			paymentAmount: [this.formatNumber(this.reservation?.invoice?.totalOutstandingBalance), Validators.required],
	// 			country: ['US'],
	// 			paymentType: ['CR'],
	// 			iAgree: [''],
	// 			paymentSourceId: [],
	// 			paymentCreditCardRequestedTransactionType:[]
	// 		}),
	// 		contract: this.formBuilder.group({
	// 			signName: [''],
	// 			signEmail: [''],
	// 			signBase64: [],
	// 		}),
	// 	});
	// }

	formBuild() {
		this.form1 = this.formBuilder.group({
			emailAddress: [],
			status: [],
			referralSourceId: [],
			creditSaleToUserId: [],
			creditSaleToUser2Id: [],
			salesTax: [],
			tax: [],
			premium: [],
			reservationStatus: [],
			holdExpirationDate: [],
			numAdults: [],
			numChildren: [],
			primaryMobilePhone: [],
			specialRequests: [],
			airportArrivalDate: [],
			airportDepartureDate: [],
			propertyArrivalDate: [],
			propertyDepartureDate: [],
			arrivalHour1: [],
			arrivalMinute1: [],
			arrivalAmPm1: [],
			arrivingAirlineName: [],
			arrivingAirlineFlightNum: [],
			arrivalHour2: [],
			arrivalMinute2: [],
			arrivalAmPm2: [],
			departingAirlineName: [],
			departingAirlineFlightNum: [],
			propertyArrivalHour1: [],
			propertyArrivalMinute1: [],
			propertyArrivalAmPm1: [],
			propertyArrivalHour2: [],
			propertyArrivalMinute2: [],
			propertyArrivalAmPm2: [],
			checkOutDate: [],
			checkInDate: [],
			specialArrivalHour: [],
			specialArrivalMinute: [],
			specialArrivalAmPm: [],
			specialDepartingHour: [],
			specialDepartingMinute: [],
			specialDepartingAmPm: [],
			guestNotes: [],
			opsNotes: [],
			lostFoundId: [],
			keyServiceType: [],
			codeFrontDoor: [],
			codeGarage: [],
			towelCode: [],
			codeGate: [],
			codeHoaGate: [],
			rentalCarBudget: [],
			rentalCarAvis: [],
			codePool: [],
			codeRecreation: [],
			earlyCheckinDate: [],
			lateCheckoutDate: [],
			ruReservationId: [],
			listingType: [],
			reservationType: [],

			guestProfile: this.formBuilder.group({
				firstName: ['', Validators.required],
				lastName: ['', Validators.required],
				title: [''],
				emailAddress: ['', [Validators.required, Validators.email]],
				mobilePhone: [],
				adrPhone: [''],
				adrStreet: [],
				adrCity: [],
				adrState: [],
				adrPostalCode: [],
				adrCountry: ['US'],
				emergencyContactNotes: [],
				travelOccasionNotes: [],
				travelOccasion: [],
				primaryMobilePhone: [],
				specialRequests: [],
				guestCompanions: new UntypedFormArray([]),
			}),

			paymentSourceDeposit: this.formBuilder.group({
				billingName: [],
				billingStreetAddress: [],
				billingCity: [],
				billingState: [],
				billingPostalCode: [],
				billingCountry: [],
				creditCardNumber: [],
				creditCardExpirationMonth: [],
				creditCardExpirationYear: [],
				creditCardSecurityCode: [''],
				paymentType: [],
				achBankName: [],
				achBankAccountNumber: [],
				achRoutingNumber: [],
				achCheckNumber: [],
				achMicrData: [],
				achBranchSortCode: [],

			}),

			paymentSourceFunding: this.formBuilder.group({
				billingName: [],
				billingStreetAddress: [],
				billingCity: [],
				billingState: [],
				billingPostalCode: [],
				billingCountry: [],
				creditCardNumber: [],
				creditCardExpirationMonth: [],
				creditCardExpirationYear: [],
				creditCardSecurityCode: [''],
				paymentType: [],
				achBankName: [],
				achBankAccountNumber: [],
				achRoutingNumber: [],
				achCheckNumber: [],
				achMicrData: [],
				achBranchSortCode: [],

			}),
		});
	}

	// not used since we are bringing the res in on a resolver
	findReservationById() {
		this.formLoading = true;
		this.reservationService.findById(this.reservationId)
			.pipe(first())
			.subscribe(
				res => {
					console.log('findReservationById1111: ' ,res);
					this.reservation = res.data.reservation;
					if (this.reservation?.resRateJson) {
						let rateLog = '[' + this.reservation?.resRateJson.replaceAll(/\n\n/g, ',') + ']';
						if (this.isJsonParsable(rateLog)) {
							this.rateLogOutput = JSON.parse(rateLog);
							const logData = [];
							this.rateLogOutput.forEach(group => {
								logData.push(...group);
								logData.push({ isBlankRow: true }); // Add blank row
							});
							this.rateLogOutput = logData;
						}
					}
					if (this.reservation?.resRateLosJson) {
						let rateLosLogOutput = '[' + this.reservation?.resRateLosJson.replaceAll(/\n\n/g, ',').replaceAll(/\]\[/g, '],[') + ']';
						if (this.isJsonParsable(rateLosLogOutput)) {
							this.rateLosLogOutput = JSON.parse(rateLosLogOutput);
							const logData = [];
							this.rateLosLogOutput.forEach(group => {
								logData.push(...group);
								logData.push({ isBlankRow: true }); // Add blank row
							});
							this.rateLosLogOutput = logData;
						}
						else {
							console.log("Not a valid JSON string:", this.rateLosLogOutput);
						}
					}
					this.getLocationByLocationId();
					if (this.reservation?.reservationStatus == "QO") {
						this.colorName = 'lightgreen';
					}
					if (this.reservation?.reservationStatus == "QH") {
						this.colorName = 'yellow';
					}
					if (this.reservation?.reservationStatus == "QE") {
						this.colorName = '#ec5300';
					}
					if (this.reservation?.reservationStatus == "OP") {
						this.colorName = 'lightgrey';
					}
					if (this.reservation?.reservationStatus == "OC") {
						this.colorName = '#FF7F7F';
					}
					if (this.reservation?.reservationStatus == "PP") {
						this.colorName = '#ffb09c';
					}
					if (this.reservation?.reservationStatus == "OX") {
						this.colorName = 'darkred';
					}
					if (this.reservation?.reservationStatus == "NA") {
						this.colorName = 'darkgray';
					}
					if (this.reservation?.reservationStatus == "OO") {
						this.colorName = 'hotpink';
					}
					if (this.reservation?.reservationStatus == "OG") {
						this.colorName = 'lightpink';
					}
					this.reservation.reservationDirty = false;

					this.checkInMinDate = moment(this.reservation?.checkInDate).toDate();
					this.checkInMaxDate = new Date(this.checkInMinDate.getFullYear() + 3, this.checkInMinDate.getMonth(), this.checkInMinDate.getDate());

					this.checkOutMinDate = moment(this.reservation?.checkOutDate).toDate();
					this.checkOutMaxDate = new Date(this.checkOutMinDate.getFullYear() + 3, this.checkOutMinDate.getMonth(), this.checkOutMinDate.getDate());

					this.getReservations.emit(this.reservation);
					this.totalAmounts = this.totalAmount();
					this.totalTaxes = this.totalTax();
					this.grandTotals = this.grandTotal();
					if (this.reservation?.reservationStatus === 'OP') {
						this.mapReservation(this.reservation);
					} else {
						this.mapReservationWithRemoveValidationOfPaymentSource(this.reservation);
					}
					this.syncCheckoutCalendarMinDateFromReservation();

				},
				err => {
					console.log('error In findReservationById is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + err.message, sticky: true });
				},
				() => { this.formLoading = false; });
	}

	private isJsonParsable(str: string): boolean {
		try {
			JSON.parse(str);
			return true;
		} catch (e) {
			return false;
		}
	}

	private syncCheckoutCalendarMinDateFromReservation(): void {
		if (!this.reservation?.checkInDate) {
			return;
		}
		const checkIn = moment(this.reservation.checkInDate).toDate();
		const minCheckout = new Date(checkIn.getTime());
		minCheckout.setDate(minCheckout.getDate() + 1);
		this.updatedCheckInDate = minCheckout;
		this.checkOutDateBasedOnCheckinDate = minCheckout;
	}

	getLocationByLocationId() {
		this.reservationService.search(this.reservation?.shortTermRental?.propertyCode, this.reservation?.shortTermRental?.locationId)
			.then(value => {

				console.log('findReservationById: ' + JSON.stringify(value));
				this.location = value.search[0];
			});
	}

	mapReservation(reservation: any) {
		this.form1 = this.formBuilder.group({
			status: reservation?.order?.status,
			referralSourceId: reservation?.order?.referralSourceId,
			ruReservationId: reservation?.ruReservationId,

			//=============================
			creditSaleToUserId: reservation?.reservationist?.userId,
			creditSaleToUser2Id: reservation?.reservationist2?.userId,
			salesTax: [],
			tax: [],
			//=============================


			premium: reservation?.order?.orderInvoice?.ccPremiumPct != null ? reservation?.order?.orderInvoice?.ccPremiumPct : "0.0000%",
			reservationStatus: reservation?.reservationStatus,
			holdExpirationDate: reservation?.holdExpirationDate,
			numAdults: reservation?.numAdults,
			numChildren: reservation?.numChildren,
			airportArrivalDate: reservation?.airportArrivalDate != null ? moment(reservation?.airportArrivalDate).toDate() : null,
			airportDepartureDate: reservation?.airportDepartureDate != null ? moment(reservation?.airportDepartureDate).toDate() : null,

			propertyArrivalDate: reservation?.propertyArrivalDate != null ? moment(reservation?.propertyArrivalDate).toDate() : null,
			propertyDepartureDate: reservation?.propertyDepartureDate != null ? moment(reservation?.propertyDepartureDate).toDate() : null,

			earlyCheckinDate: reservation?.earlyCheckinDate != null ? moment(reservation?.earlyCheckinDate).toDate() : null,
			lateCheckoutDate: reservation?.lateCheckoutDate != null ? moment(reservation?.lateCheckoutDate).toDate() : null,
			// airportArrivalDate: reservation?.airportArrivalDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.airportArrivalDate).toDate()) : null,
			// airportDepartureDate: reservation?.airportDepartureDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.airportDepartureDate).toDate()) : null,

			// earlyCheckinDate: reservation?.earlyCheckinDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.earlyCheckinDate).toDate()) : null,
			// lateCheckoutDate: reservation?.lateCheckoutDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.lateCheckoutDate).toDate()) : null,
			//===============================
			arrivalHour1: [],
			arrivalMinute1: [],
			arrivalAmPm1: [],
			//===================================

			arrivingAirlineName: reservation?.arrivingAirlineName,
			arrivingAirlineFlightNum: reservation?.arrivingAirlineFlightNum,

			//=============================
			arrivalHour2: [],
			arrivalMinute2: [],
			arrivalAmPm2: [],
			//===============================


			departingAirlineName: reservation?.departingAirlineName,
			departingAirlineFlightNum: reservation?.departingAirlineFlightNum,

			//==============================
			propertyArrivalHour1: [],
			propertyArrivalMinute1: [],
			propertyArrivalAmPm1: [],
			propertyArrivalHour2: [],
			propertyArrivalMinute2: [],
			propertyArrivalAmPm2: [],
			//=======================================

			checkOutDate: moment(reservation?.checkOutDate).toDate(),
			checkInDate: moment(reservation?.checkInDate).toDate(),

			//=====================================
			specialArrivalHour: [],
			specialArrivalMinute: [],
			specialArrivalAmPm: [],
			specialDepartingHour: [],
			specialDepartingMinute: [],
			specialDepartingAmPm: [],
			//====================================

			guestNotes: reservation?.guestNotes,
			opsNotes: reservation?.opsNotes,
			lostFoundId: [],
			keyServiceType: reservation?.keyServiceType,
			codeFrontDoor: reservation?.codeFrontDoor,
			codeGarage: reservation?.codeGarage,
			towelCode: reservation?.towelCode,
			codeGate: reservation?.codeGate,
			codeHoaGate: reservation?.codeHoaGate,
			rentalCarBudget: reservation?.rentalCarBudget,
			rentalCarAvis: reservation?.rentalCarAvis,
			codePool: reservation?.codePool,
			codeRecreation: reservation?.codeRecreation,
			primaryMobilePhone: reservation?.primaryMobilePhone,
			specialRequests: reservation?.specialRequests,

			listingType: reservation?.shortTermRental?.listingType,
			reservationType: reservation?.reservationType,

			guestProfile: this.formBuilder.group({
				guestProfileId: [reservation?.guestProfile?.guestProfileId],
				countryCodeOfPrimaryMobilePhone: this.splitCountryCode(reservation?.primaryMobilePhone, undefined),
				primaryMobilePhone: this.splitMobileNumber(reservation?.primaryMobilePhone),
				firstName: [reservation?.guestProfile?.firstName, Validators.required],
				lastName: [reservation?.guestProfile?.lastName, Validators.required],
				title: reservation?.guestProfile?.title,
				emailAddress: [reservation?.guestProfile?.emailAddress, Validators.required],
				countryCodeOfMobilePhone: this.splitCountryCode(reservation?.guestProfile?.mobilePhone, reservation?.guestProfile?.countryCode),
				mobilePhone: this.splitMobileNumber(reservation?.guestProfile?.mobilePhone),
				adrPhone: reservation?.guestProfile?.adrPhone,
				adrStreet: reservation?.guestProfile?.adrStreet,
				adrCity: reservation?.guestProfile?.adrCity,
				adrState: reservation?.guestProfile?.adrState,
				adrPostalCode: reservation?.guestProfile?.adrPostalCode,
				adrCountry: reservation?.guestProfile?.adrCountry != null ? reservation?.guestProfile?.adrCountry : 'US',
				emergencyContactNotes: reservation?.guestProfile?.emergencyContactNotes,
				travelOccasionNotes: reservation?.guestProfile?.travelOccasionNotes,
				travelOccasion: reservation?.guestProfile?.travelOccasion,
				guestCompanions: new UntypedFormArray([]),
			}),

			paymentSourceDeposit: this.formBuilder.group({

				billingName: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingName,
				billingStreetAddress: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingStreetAddress,
				billingCity: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingCity,
				billingState: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingState,
				billingPostalCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingPostalCode,
				billingCountry: 'US',
				creditCardNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardNumber,
				creditCardExpirationMonth: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardExpirationMonth,
				creditCardExpirationYear: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardExpirationYear,
				creditCardSecurityCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardSecurityCode,
				paymentType: reservation?.order?.orderInvoice?.paymentSourceDeposit?.paymentType,
				achBankName: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBankName,
				achBankAccountNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBankAccountNumber,
				achRoutingNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achRoutingNumber,
				achCheckNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achCheckNumber,
				achMicrData: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achMicrData,
				achBranchSortCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBranchSortCode,

			}),

			paymentSourceFunding: this.formBuilder.group({

				billingName: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingName,
				billingStreetAddress: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingStreetAddress,
				billingCity: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingCity,
				billingState: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingState,
				billingPostalCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingPostalCode,
				billingCountry: 'US',
				creditCardNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardNumber,
				creditCardExpirationMonth: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardExpirationMonth,
				creditCardExpirationYear: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardExpirationYear,
				creditCardSecurityCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardSecurityCode,
				paymentType: reservation?.order?.orderInvoice?.paymentSourceFunding?.paymentType,
				achBankName: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBankName,
				achBankAccountNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBankAccountNumber,
				achRoutingNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achRoutingNumber,
				achCheckNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achCheckNumber,
				achMicrData: reservation?.order?.orderInvoice?.paymentSourceFunding?.achMicrData,
				achBranchSortCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBranchSortCode,

			}),
		});
		if (this.reservation?.guestProfile?.guestCompanions.length > 0) {
			this.reservation?.guestProfile?.guestCompanions.forEach((campanion: any) => {
				this.guestCompanions.push(this.mapCompanion(campanion));
			});
		}
		// if(this.reservation?.guestProfile?.guestCompanions.length == 0 || this.reservation?.guestProfile?.guestCompanions.length == null || this.reservation?.guestProfile?.guestCompanions.length == undefined){
		// 	for (let i = 1; i < (this.reservation?.numAdults + this.reservation?.numChildren); i++) {
		// 		if (this.guestCompanions.length < i) {
		// 			this.guestCompanions.push(this.newCompanion());
		// 		}
		// 	}
		// }

		this.isLoadData = true;
	}

	splitMobileNumber(fullNumber: any) {
		fullNumber = fullNumber?.replace(/\D/g, ''); // remove non-digits
		if (!fullNumber) return;

		if (fullNumber.length > 10) {
			// Split: everything before last 10 digits = country code
			const countryCode = '+' + fullNumber.slice(0, fullNumber.length - 10);
			const mobileNumber = fullNumber.slice(-10);

			return mobileNumber
		} else if (fullNumber.length === 10) {
			// Only mobile number
			return fullNumber;
		}
	}

	splitCountryCode(fullNumber: any, countryCode: any) {
		fullNumber = fullNumber?.replace(/\D/g, ''); // remove non-digits
		if (!fullNumber) return;

		if (fullNumber.length > 10) {
			// Split: everything before last 10 digits = country code
			const countryCode = '+' + fullNumber.slice(0, fullNumber.length - 10);
			const mobileNumber = fullNumber.slice(-10);

			return countryCode
		} else {
      if(countryCode){
        return countryCode
      }
			// Only mobile number
			return null;
		}
	}


	formatNumber(number: any): any {
		if (number) {
			return numberFormatter.format(number);
		}
		else {
			'';
		}
	}

	mapReservationWithRemoveValidationOfPaymentSource(reservation: any) {
		this.form1 = this.formBuilder.group({
			status: reservation?.order?.status,
			referralSourceId: reservation?.order?.referralSourceId,
			ruReservationId: reservation?.ruReservationId,

			//=============================
			creditSaleToUserId: reservation?.reservationist?.userId,
			creditSaleToUser2Id: reservation?.reservationist2?.userId,
			salesTax: [],
			tax: [],
			//=============================


			premium: reservation?.order?.orderInvoice?.ccPremiumPct != null ? reservation?.order?.orderInvoice?.ccPremiumPct : "0.0000%",
			reservationStatus: reservation?.reservationStatus,
			holdExpirationDate: reservation?.holdExpirationDate,
			numAdults: reservation?.numAdults,
			numChildren: reservation?.numChildren,
			airportArrivalDate: reservation?.airportArrivalDate != null ? moment(reservation?.airportArrivalDate).toDate() : null,
			airportDepartureDate: reservation?.airportDepartureDate != null ? moment(reservation?.airportDepartureDate).toDate() : null,

			propertyArrivalDate: reservation?.propertyArrivalDate != null ? moment(reservation?.propertyArrivalDate).toDate() : null,
			propertyDepartureDate: reservation?.propertyDepartureDate != null ? moment(reservation?.propertyDepartureDate).toDate() : null,

			earlyCheckinDate: reservation?.earlyCheckinDate != null ? moment(reservation?.earlyCheckinDate).toDate() : null,
			lateCheckoutDate: reservation?.lateCheckoutDate != null ? moment(reservation?.lateCheckoutDate).toDate() : null,

			// airportArrivalDate: reservation?.airportArrivalDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.airportArrivalDate).toDate()) : null,
			//   airportDepartureDate: reservation?.airportDepartureDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.airportDepartureDate).toDate()) : null,

			//   earlyCheckinDate: reservation?.earlyCheckinDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.earlyCheckinDate).toDate()) : null,
			//   lateCheckoutDate: reservation?.lateCheckoutDate != null ? this.addLocalTimeToDateTime(moment.utc(reservation?.lateCheckoutDate).toDate()) : null,

			//===============================
			// arrivalHour1: [],
			// arrivalMinute1: [],
			// arrivalAmPm1: [],
			//===================================

			arrivingAirlineName: reservation?.arrivingAirlineName,
			arrivingAirlineFlightNum: reservation?.arrivingAirlineFlightNum,

			//=============================
			// arrivalHour2: [],
			// arrivalMinute2: [],
			// arrivalAmPm2: [],
			//===============================


			departingAirlineName: reservation?.departingAirlineName,
			departingAirlineFlightNum: reservation?.departingAirlineFlightNum,

			//==============================
			propertyArrivalHour1: [],
			propertyArrivalMinute1: [],
			propertyArrivalAmPm1: [],
			propertyArrivalHour2: [],
			propertyArrivalMinute2: [],
			propertyArrivalAmPm2: [],
			//=======================================

			checkOutDate: moment(reservation?.checkOutDate).toDate(),
			checkInDate: moment(reservation?.checkInDate).toDate(),

			//=====================================
			// specialArrivalHour: [],
			// specialArrivalMinute: [],
			// specialArrivalAmPm: [],
			// specialDepartingHour: [],
			// specialDepartingMinute: [],
			// specialDepartingAmPm: [],
			//====================================

			guestNotes: reservation?.guestNotes,
			opsNotes: reservation?.opsNotes,
			lostFoundId: [],
			keyServiceType: reservation?.keyServiceType,
			codeFrontDoor: reservation?.codeFrontDoor,
			codeGarage: reservation?.codeGarage,
			towelCode: reservation?.towelCode,
			codeGate: reservation?.codeGate,
			codeHoaGate: reservation?.codeHoaGate,
			rentalCarBudget: reservation?.rentalCarBudget,
			rentalCarAvis: reservation?.rentalCarAvis,
			codePool: reservation?.codePool,
			codeRecreation: reservation?.codeRecreation,
			primaryMobilePhone: reservation?.primaryMobilePhone,
			specialRequests: reservation?.specialRequests,
			listingType: reservation?.shortTermRental?.listingType,
			reservationType: reservation?.reservationType,

			guestProfile: this.formBuilder.group({
				guestProfileId: [reservation?.guestProfile?.guestProfileId],
				countryCodeOfPrimaryMobilePhone: this.splitCountryCode(reservation?.primaryMobilePhone, undefined),
				primaryMobilePhone: this.splitMobileNumber(reservation?.primaryMobilePhone),
				firstName: [reservation?.guestProfile?.firstName, Validators.required],
				lastName: [reservation?.guestProfile?.lastName, Validators.required],
				title: reservation?.guestProfile?.title,
				emailAddress: [reservation?.guestProfile?.emailAddress, Validators.required],
				countryCodeOfMobilePhone: this.splitCountryCode(reservation?.guestProfile?.mobilePhone, reservation?.guestProfile?.countryCode),
				mobilePhone: this.splitMobileNumber(reservation?.guestProfile?.mobilePhone),
				adrPhone: reservation?.guestProfile?.adrPhone,
				adrStreet: reservation?.guestProfile?.adrStreet,
				adrCity: reservation?.guestProfile?.adrCity,
				adrState: reservation?.guestProfile?.adrState,
				adrPostalCode: reservation?.guestProfile?.adrPostalCode,
				adrCountry: reservation?.guestProfile?.adrCountry != null ? reservation?.guestProfile?.adrCountry : 'US',
				emergencyContactNotes: reservation?.guestProfile?.emergencyContactNotes,
				travelOccasionNotes: reservation?.guestProfile?.travelOccasionNotes,
				travelOccasion: reservation?.guestProfile?.travelOccasion,
				guestCompanions: new UntypedFormArray([]),
			}),

			paymentSourceDeposit: this.formBuilder.group({

				billingName: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingName,
				billingStreetAddress: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingStreetAddress,
				billingCity: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingCity,
				billingState: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingState,
				billingPostalCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.billingPostalCode,
				billingCountry: ['US'],
				creditCardNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardNumber,
				creditCardExpirationMonth: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardExpirationMonth,
				creditCardExpirationYear: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardExpirationYear,
				creditCardSecurityCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.creditCardSecurityCode,
				paymentType: reservation?.order?.orderInvoice?.paymentSourceDeposit?.paymentType,
				achBankName: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBankName,
				achBankAccountNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBankAccountNumber,
				achRoutingNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achRoutingNumber,
				achCheckNumber: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achCheckNumber,
				achMicrData: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achMicrData,
				achBranchSortCode: reservation?.order?.orderInvoice?.paymentSourceDeposit?.achBranchSortCode,

			}),

			paymentSourceFunding: this.formBuilder.group({

				billingName: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingName,
				billingStreetAddress: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingStreetAddress,
				billingCity: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingCity,
				billingState: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingState,
				billingPostalCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.billingPostalCode,
				billingCountry: ['US'],
				creditCardNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardNumber,
				creditCardExpirationMonth: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardExpirationMonth,
				creditCardExpirationYear: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardExpirationYear,
				creditCardSecurityCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.creditCardSecurityCode,
				paymentType: reservation?.order?.orderInvoice?.paymentSourceFunding?.paymentType,
				achBankName: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBankName,
				achBankAccountNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBankAccountNumber,
				achRoutingNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achRoutingNumber,
				achCheckNumber: reservation?.order?.orderInvoice?.paymentSourceFunding?.achCheckNumber,
				achMicrData: reservation?.order?.orderInvoice?.paymentSourceFunding?.achMicrData,
				achBranchSortCode: reservation?.order?.orderInvoice?.paymentSourceFunding?.achBranchSortCode,

			}),
		});
		if (this.reservation?.guestProfile?.guestCompanions.length > 0) {
			this.reservation?.guestProfile?.guestCompanions.forEach((campanion: any) => {
				this.guestCompanions.push(this.mapCompanion(campanion));
			});
		}
		// if(this.reservation?.guestProfile?.guestCompanions.length == 0 || this.reservation?.guestProfile?.guestCompanions.length == null || this.reservation?.guestProfile?.guestCompanions.length == undefined){
		// 	for (let i = 1; i < (this.reservation?.numAdults + this.reservation?.numChildren); i++) {
		// 		if (this.guestCompanions.length < i) {
		// 			this.guestCompanions.push(this.newCompanion());
		// 		}
		// 	}
		// }
		this.isLoadData = true;
	}

	onOpenFormWorkOrder() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "40vw";
		dialogConfig.width = "30vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Word Order Detail',
			reservation: this.reservation
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(WorkOrderComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addWorkOrderCB(data);
				this.findReservationById();
				// close the dialogBox
				dialogRef.close();
			});
	}

	onOpenForEditWorkOrder(workOrder: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "40vw";
		dialogConfig.width = "30vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Edit Word Order Detail',
			reservation: this.reservation,
			workOrder: workOrder
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(WorkOrderComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.findReservationById();
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addWorkOrderCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	addWorkOrderCB(workOrder: WorkOrder) {
		console.log('Adding OrderDetail: ' + JSON.stringify(workOrder));
		// if we don't have a orderDetails array yet...
		if (!this.workOrders) {
			this.workOrders = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.workOrders.unshift(workOrder);

		// no idea what this is but it is required to update the array
		this.workOrders = [...this.workOrders];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'WorkOrder ' + workOrder.workOrderId + ' Added', life: 1000 });
	}

	gotoReservation() {
		this.location1.go('/reservations');
		this.router.navigate(['reservations']);
	}

	handleChange(e) {
		console.log("index : " + e.index);
		var index = e.index;
		if (index == 3) {
			this.getLostFound();
		}
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	getLostFound() {
		this.lostFoundService.findByReservationId(this.reservation.reservationId)
			.pipe(first())
			.subscribe(
				res => {
					console.log('findReservationById: ' + JSON.stringify(res));
					this.lostFounds = res.data.lostFounds;
				},
				err => {
					console.log('error In findReservationById is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + err.message, sticky: true });
				},
				() => { this.formLoading = false; });
	}

	sendReviewEmailBeforeCheckout() {
		this.formLoading = true;
		this.reservationService.sendReviewEmailBeforeCheckout(this.reservation)
			.pipe(first())
			.subscribe(
				res => {
					console.log('findReservationById: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email send successfully', life: 1000 });
				},
				err => {
					// Do NOT reset formLoading on error — a 504 means the email may have been sent.
					// Keep button disabled to prevent a duplicate email from being triggered.
					console.log('error sending review email: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Email send failed. Please refresh before retrying: ' + err.message, sticky: true });
				},
				() => { this.formLoading = false; });
	}

	sendReviewEmailAfterCheckout() {
		this.formLoading = true;
		this.reservationService.sendReviewEmailAfterCheckout(this.reservation)
			.pipe(first())
			.subscribe(
				res => {
					console.log('findReservationById: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email send successfully', life: 1000 });
				},
				err => {
					// Do NOT reset formLoading on error — a 504 means the email may have been sent.
					// Keep button disabled to prevent a duplicate email from being triggered.
					console.log('error sending review email: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Email send failed. Please refresh before retrying: ' + err.message, sticky: true });
				},
				() => { this.formLoading = false; });
	}

	get hardDeleteEntries(): {key: string, value: any}[] {
		if (!this.hardDeleteResult) return [];
		return Object.entries(this.hardDeleteResult).map(([key, value]) => ({ key, value }));
	}

	hardDeleteConfirm() {
		const orderId = this.reservation?.order?.orderId;
		if (!orderId) return;
		this.hardDeletePasswordValue = '';
		this.hardDeletePasswordError = '';
		this.pendingHardDeleteOrderId = orderId;
		this.hardDeletePasswordDialogVisible = true;
	}

	onHardDeletePasswordConfirm() {
		if (this.hardDeletePasswordValue !== '@lohaKBM1!') {
			this.hardDeletePasswordError = 'Incorrect password.';
			return;
		}
		this.hardDeletePasswordDialogVisible = false;
		this.hardDeletePasswordValue = '';
		this.hardDeletePasswordError = '';
		if (this.pendingHardDeleteOrderId) {
			this.doHardDelete(this.pendingHardDeleteOrderId);
			this.pendingHardDeleteOrderId = null;
		}
	}

	onHardDeletePasswordCancel() {
		this.hardDeletePasswordDialogVisible = false;
		this.hardDeletePasswordValue = '';
		this.hardDeletePasswordError = '';
		this.pendingHardDeleteOrderId = null;
	}

	doHardDelete(orderId: number) {
		this.hardDeleting = true;
		this.reservationService.hardDeleteOrder(orderId)
			.pipe(first())
			.subscribe(
				res => {
					this.hardDeleteResult = res.data?.deleted ?? res.data?.result ?? res.data;
					this.showHardDeleteResult = true;
				},
				err => {
					const msg = err?.error?.message || err?.message || 'Hard delete failed';
					this.messageService.add({ severity: 'error', summary: 'Hard Delete Failed', detail: msg, sticky: true });
					this.hardDeleting = false;
				},
				() => { this.hardDeleting = false; }
			);
	}

	reservationStatusConfBox() {
		this.confirmationService.confirm({
			message: 'Are you sure you want to change reservation status to "' + this.getReservationStatus(this.form1.value.reservationStatus) + '"? for ReservationId# ' + this.reservationId,
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.updateReservationStatusAndAdult();
			},
			reject: () => {
				this.form1.patchValue({
					reservationStatus: this.reservation.reservationStatus
				})
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Status changed canceled.', life: 1000 });
			}
		});
	}

	reservationTypeConfBox() {
		this.confirmationService.confirm({
			message: 'Are you sure you want to change reservation type to "' + this.getReservationType(this.form1.value.reservationType) + '"? for ReservationId# ' + this.reservationId,
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.updateReservationStatusAndAdult();
			},
			reject: () => {
				this.form1.patchValue({
					reservationType: this.reservation.reservationType
				})
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Status changed canceled.', life: 1000 });
			}
		});
	}

	updateReservation() {
		// stop here if form is invalid
		this.form1.markAllAsTouched();
		if (this.form1.invalid) {
			return;
		}
		// this.formLoading = true;
		this.reservation.order.status = this.form1.value.status;
		this.reservation.order.referralSourceId = this.form1.value.referralSourceId;
		this.reservation.ruReservationId = this.form1.value.ruReservationId;

		//=============================
		// creditSaleToUserId: [],
		// creditSaleToUser2Id: [],
		// salesTax: [],
		// tax: [] = this.form1.value.
		//=============================
		if (this.form1.value.premium !== "0.0000%") {
			this.reservation.order.orderInvoice.ccPremiumPct = this.form1.value.premium;
		}
		this.reservation.reservationStatus = this.form1.value.reservationStatus;
		this.reservation.numAdults = this.form1.value.numAdults;
		this.reservation.numChildren = this.form1.value.numChildren;
		if (this.form1.value.airportArrivalDate != undefined && this.form1.value.airportArrivalDate != null && this.form1.value.airportArrivalDate != "") {
			this.reservation.airportArrivalDate = this.addLocalTimeToDateTime(new Date(this.form1.value.airportArrivalDate));
		} else {
			this.reservation.airportArrivalDate = null;
		}
		if (this.form1.value.airportDepartureDate != undefined && this.form1.value.airportDepartureDate != null && this.form1.value.airportDepartureDate != "") {
			this.reservation.airportDepartureDate = this.addLocalTimeToDateTime(new Date(this.form1.value.airportDepartureDate));
		} else {
			this.reservation.airportDepartureDate = null;
		}

		if (this.form1.value.propertyArrivalDate != undefined && this.form1.value.propertyArrivalDate != null && this.form1.value.propertyArrivalDate != "") {
			this.reservation.propertyArrivalDate = this.addLocalTimeToDateTime(new Date(this.form1.value.propertyArrivalDate));
		} else {
			this.reservation.propertyArrivalDate = null;
		}
		if (this.form1.value.propertyDepartureDate != undefined && this.form1.value.propertyDepartureDate != null && this.form1.value.propertyDepartureDate != "") {
			this.reservation.propertyDepartureDate = this.addLocalTimeToDateTime(new Date(this.form1.value.propertyDepartureDate));
		} else {
			this.reservation.propertyDepartureDate = null;
		}

		if (this.form1.value.earlyCheckinDate != undefined && this.form1.value.earlyCheckinDate != null && this.form1.value.earlyCheckinDate != "") {
			this.reservation.earlyCheckinDate = this.addLocalTimeToDateTime(new Date(this.form1.value.earlyCheckinDate));
		} else {
			this.reservation.earlyCheckinDate = null;
		}

		if (this.form1.value.lateCheckoutDate != undefined && this.form1.value.lateCheckoutDate != null && this.form1.value.lateCheckoutDate != "") {
			this.reservation.lateCheckoutDate = this.addLocalTimeToDateTime(new Date(this.form1.value.lateCheckoutDate));
		} else {
			this.reservation.lateCheckoutDate = null;
		}


		//===============================
		// arrivalHour1: [] = this.form1.value.
		// arrivalMinute1: [] = this.form1.value.
		// arrivalAmPm1: [] = this.form1.value.
		//===================================

		this.reservation.arrivingAirlineName = this.form1.value.arrivingAirlineName;
		this.reservation.arrivingAirlineFlightNum = this.form1.value.arrivingAirlineFlightNum;

		//=============================
		// arrivalHour2: [] = this.form1.value.
		// arrivalMinute2: [] = this.form1.value.
		// arrivalAmPm2: [] = this.form1.value.
		//===============================


		this.reservation.departingAirlineName = this.form1.value.departingAirlineName;
		this.reservation.departingAirlineFlightNum = this.form1.value.departingAirlineFlightNum;

		//==============================
		// propertyArrivalHour1: [] = this.form1.value.
		// propertyArrivalMinute1: [] = this.form1.value.
		// propertyArrivalAmPm1: [] = this.form1.value.
		// propertyArrivalHour2: [] = this.form1.value.
		// propertyArrivalMinute2: [] = this.form1.value.
		// propertyArrivalAmPm2: [] = this.form1.value.
		//=======================================

		this.reservation.checkOutDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkOutDate));
		this.reservation.checkInDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkInDate));

		//=====================================
		// specialArrivalHour: [] = this.form1.value.
		// specialArrivalMinute: [] = this.form1.value.
		// specialArrivalAmPm: [] = this.form1.value.
		// specialDepartingHour: [] = this.form1.value.
		// specialDepartingMinute: [] = this.form1.value.
		// specialDepartingAmPm: [] = this.form1.value.
		//====================================

		this.reservation.guestNotes = this.form1.value.guestNotes;
		this.reservation.opsNotes = this.form1.value.opsNotes;
		// lostFoundId: [] = this.form1.value.
		this.reservation.keyServiceType = this.form1.value.keyServiceType;
		this.reservation.codeFrontDoor = this.form1.value.codeFrontDoor;
		this.reservation.codeGarage = this.form1.value.codeGarage;
		this.reservation.towelCode = this.form1.value.towelCode,
			this.reservation.codeGate = this.form1.value.codeGate;
		this.reservation.codeHoaGate = this.form1.value.codeHoaGate;
		this.reservation.rentalCarBudget = this.form1.value.rentalCarBudget;
		this.reservation.rentalCarAvis = this.form1.value.rentalCarAvis;
		this.reservation.codePool = this.form1.value.codePool;
		this.reservation.codeRecreation = this.form1.value.codeRecreation;
		this.reservation.primaryMobilePhone = `${this.form1.value.guestProfile?.countryCodeOfPrimaryMobilePhone || ''}${this.form1.value.guestProfile?.primaryMobilePhone}`;
		this.reservation.specialRequests = this.form1.value.specialRequests;
		// this.reservation.earlyCheckinDate = this.reservation.earlyCheckinDate;
		// this.reservation.lateCheckoutDate = this.reservation.lateCheckoutDate;

		if (!this.reservation.guestProfile) {
			this.reservation.guestProfile = {
				guestProfileId: null,
				firstName: "",
				lastName: "",
				title: "",
				emailAddress: "",
				mobilePhone: "",
				adrPhone: "",
				adrStreet: "",
				adrCity: "",
				adrState: "",
				adrPostalCode: "",
				adrCountry: "",
				emergencyContactNotes: "",
				travelOccasionNotes: "",
				travelOccasion: "",
				guestCompanions: []
			};
		}


		if (this.reservation?.guestProfile != null && this.reservation?.guestProfile != undefined) {
			this.reservation.guestProfile.firstName = this.form1.value.guestProfile?.firstName || "";
			this.reservation.guestProfile.lastName = this.form1.value.guestProfile?.lastName || "";
			this.reservation.guestProfile.title = this.form1.value.guestProfile?.title || "";
			this.reservation.guestProfile.emailAddress = this.form1.value.guestProfile?.emailAddress || "";
			this.reservation.guestProfile.mobilePhone =
				`${this.form1.value.guestProfile?.countryCodeOfMobilePhone || ''}${this.form1.value.guestProfile?.mobilePhone || ''}`;
			this.reservation.guestProfile.adrPhone = this.form1.value.guestProfile?.adrPhone || "";
			this.reservation.guestProfile.adrStreet = this.form1.value.guestProfile?.adrStreet || "";
			this.reservation.guestProfile.adrCity = this.form1.value.guestProfile?.adrCity || "";
			this.reservation.guestProfile.adrState = this.form1.value.guestProfile?.adrState || "";
			this.reservation.guestProfile.adrPostalCode = this.form1.value.guestProfile?.adrPostalCode || "";
			this.reservation.guestProfile.adrCountry = this.form1.value.guestProfile?.adrCountry || "US";
			this.reservation.guestProfile.emergencyContactNotes = this.form1.value.guestProfile?.emergencyContactNotes || "";
			this.reservation.guestProfile.travelOccasionNotes = this.form1.value.guestProfile?.travelOccasionNotes || "";
			this.reservation.guestProfile.travelOccasion = this.form1.value.guestProfile?.travelOccasion || "";
			this.reservation.guestProfile.guestCompanions = this.form1.value.guestProfile?.guestCompanions || [];
		}
		// if(this.guestCompanions.length > 0){
		// this.reservation.guestProfile.guestCompanions = this.form1.value.guestProfile?.guestCompanions;
		// }

		if (this.reservation.order.orderInvoice.paymentSourceDeposit == null || this.reservation.order.orderInvoice.paymentSourceDeposit == undefined) {
			const paymentData = {
				billingName: "",
				billingStreetAddress: "",
				billingCity: "",
				billingState: "",
				billingPostalCode: "",
				billingCountry: "",
				creditCardNumber: "",
				creditCardExpirationMonth: "",
				creditCardExpirationYear: "",
				creditCardSecurityCode: "",
				paymentType: "",
				achBankName: "",
				achBankAccountNumber: "",
				achRoutingNumber: "",
				achCheckNumber: "",
				achMicrData: "",
				achBranchSortCode: "",
			}
			this.reservation.order.orderInvoice.paymentSourceDeposit = paymentData;
		}

		this.reservation.order.orderInvoice.paymentSourceDeposit.billingName = this.form1.value.paymentSourceDeposit.billingName;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingStreetAddress = this.form1.value.paymentSourceDeposit.billingStreetAddress;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingCity = this.form1.value.paymentSourceDeposit.billingCity;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingState = this.form1.value.paymentSourceDeposit.billingState;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingPostalCode = this.form1.value.paymentSourceDeposit.billingPostalCode;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingCountry = this.form1.value.paymentSourceDeposit.billingCountry;
		this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardNumber = this.form1.value.paymentSourceDeposit.creditCardNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationMonth = this.form1.value.paymentSourceDeposit.creditCardExpirationMonth;
		this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationYear = this.form1.value.paymentSourceDeposit.creditCardExpirationYear;
		if (this.form1.value.paymentSourceDeposit.creditCardSecurityCode != null && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != undefined && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != "") {
			this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardSecurityCode = this.form1.value.paymentSourceDeposit.creditCardSecurityCode.toString();
		}
		this.reservation.order.orderInvoice.paymentSourceDeposit.paymentType = this.form1.value.paymentSourceDeposit.paymentType;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achBankName = this.form1.value.paymentSourceDeposit.achBankName;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achBankAccountNumber = this.form1.value.paymentSourceDeposit.achBankAccountNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achRoutingNumber = this.form1.value.paymentSourceDeposit.achRoutingNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achCheckNumber = this.form1.value.paymentSourceDeposit.achCheckNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achMicrData = this.form1.value.paymentSourceDeposit.achMicrData;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achBranchSortCode = this.form1.value.paymentSourceDeposit.achBranchSortCode;


		if (this.reservation.order.orderInvoice.paymentSourceFunding == null || this.reservation.order.orderInvoice.paymentSourceFunding == undefined) {
			const paymentData = {
				billingName: "",
				billingStreetAddress: "",
				billingCity: "",
				billingState: "",
				billingPostalCode: "",
				billingCountry: "",
				creditCardNumber: "",
				creditCardExpirationMonth: "",
				creditCardExpirationYear: "",
				creditCardSecurityCode: "",
				paymentType: "",
				achBankName: "",
				achBankAccountNumber: "",
				achRoutingNumber: "",
				achCheckNumber: "",
				achMicrData: "",
				achBranchSortCode: "",
			}
			this.reservation.order.orderInvoice.paymentSourceFunding = paymentData;
		}

		this.reservation.order.orderInvoice.paymentSourceFunding.billingName = this.form1.value.paymentSourceFunding.billingName;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingStreetAddress = this.form1.value.paymentSourceFunding.billingStreetAddress;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingCity = this.form1.value.paymentSourceFunding.billingCity;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingState = this.form1.value.paymentSourceFunding.billingState;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingPostalCode = this.form1.value.paymentSourceFunding.billingPostalCode;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingCountry = this.form1.value.paymentSourceFunding.billingCountry;
		this.reservation.order.orderInvoice.paymentSourceFunding.creditCardNumber = this.form1.value.paymentSourceFunding.creditCardNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationMonth = this.form1.value.paymentSourceFunding.creditCardExpirationMonth;
		this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationYear = this.form1.value.paymentSourceFunding.creditCardExpirationYear;
		if (this.form1.value.paymentSourceFunding.creditCardSecurityCode != null && this.form1.value.paymentSourceFunding.creditCardSecurityCode != undefined && this.form1.value.paymentSourceFunding.creditCardSecurityCode != "") {
			this.reservation.order.orderInvoice.paymentSourceFunding.creditCardSecurityCode = this.form1.value.paymentSourceFunding.creditCardSecurityCode.toString();
		}
		this.reservation.order.orderInvoice.paymentSourceFunding.paymentType = this.form1.value.paymentSourceFunding.paymentType;
		this.reservation.order.orderInvoice.paymentSourceFunding.achBankName = this.form1.value.paymentSourceFunding.achBankName;
		this.reservation.order.orderInvoice.paymentSourceFunding.achBankAccountNumber = this.form1.value.paymentSourceFunding.achBankAccountNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.achRoutingNumber = this.form1.value.paymentSourceFunding.achRoutingNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.achCheckNumber = this.form1.value.paymentSourceFunding.achCheckNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.achMicrData = this.form1.value.paymentSourceFunding.achMicrData;
		this.reservation.order.orderInvoice.paymentSourceFunding.achBranchSortCode = this.form1.value.paymentSourceFunding.achBranchSortCode;


		this.reservation.reservationDirty = true;
		this.getReservations.emit(this.reservation);
		// this.alertService.error('Please enter a title first before entering any other fields.');
		// this.reservationService.updateGuestInfo(this.reservation)
		// 	.pipe(first())
		// 	.subscribe(
		// 		res => {
		// 			console.log('findReservationById: ' + JSON.stringify(res));
		// 			this.alertService.success("Reservation update successfully", true);
		// 			// this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Update reservation successfully', life: 1000 });
		// 			// this.reservation = res.data.reservation;
		// 			// this.findReservationById();
		// 		},
		// 		err => {
		// 			this.alertService.error(err, true);
		// 			console.log('error reservation update: ' + JSON.stringify(err));
		// 			this.formLoading = false;
		// 			// this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation update fail: ' + err, sticky: true });
		// 		},
		// 		() => { this.formLoading = false; });
	}

	grandTotal() {
		let total = 0
		if (this.reservation?.order?.orderInvoice?.orderDetails.length > 0) {
			this.reservation?.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
				total += orderDetail?.total
			});
		}
		return total;
	}

	totalTax() {
		let total = 0
		if (this.reservation?.order?.orderInvoice?.orderDetails.length > 0) {
			this.reservation?.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
				total += orderDetail?.tax
			});
		}
		return total;
	}
	totalAmount() {
		let total = 0;
		if (this.reservation?.order?.orderInvoice?.orderDetails.length > 0) {
			this.reservation?.order?.orderInvoice?.orderDetails.forEach(orderDetail => {
				total += orderDetail?.subTotal
			});
		}
		return total;
	}


	private generateInvoicePDF(): Promise<{ doc: jsPDF, fileName: string }> {
		return new Promise((resolve, reject) => {
			if (!this.reservation && !this.order) {
				reject(new Error('Reservation or Order data not available'));
				return;
			}

			const loadImageAsDataUrl = (src: string): Promise<string> => {
				return new Promise((resolveImg, rejectImg) => {
					const img = new Image();
					img.crossOrigin = 'anonymous';
					img.onload = () => {
						const canvas = document.createElement('canvas');
						canvas.width = img.width;
						canvas.height = img.height;
						const ctx = canvas.getContext('2d');
						if (ctx) {
							ctx.drawImage(img, 0, 0);
							resolveImg(canvas.toDataURL('image/png'));
						} else {
							rejectImg(new Error('Could not get canvas context'));
						}
					};
					img.onerror = rejectImg;
					img.src = src;
				});
			};

			loadImageAsDataUrl('/assets/img/header-logo.png')
				.then((logoDataUrl: string) => {
					try {
						const orderData = this.order || this.reservation?.order;
						const allOrderDetails = orderData?.orderInvoice?.orderDetails || [];
						const allPayments = orderData?.orderInvoice?.orderInvoiceDetails || [];
						const reservations = (this.reservation ? [this.reservation] : []);

						const hasMultipleReservations = reservations.length > 1;

						const generateInvoiceForReservation = (doc: jsPDF, reservation: any, isFirstPage: boolean, logoData: string) => {
						const pageWidth = doc.internal.pageSize.getWidth();
						const margin = 40;
						let yPos = margin;

						if (!isFirstPage) {
							doc.addPage();
							yPos = margin;
						}

						const reservationOrderDetails = allOrderDetails.filter((detail: any) =>
							detail.reservationId === reservation.reservationId
						);

						const reservationPayments = allPayments.filter((payment: any) =>
							!payment.reservationId || payment.reservationId === reservation.reservationId
						);

						const subTotal = reservationOrderDetails.reduce((sum: number, detail: any) => sum + (detail.subTotal || 0), 0);
						const totalTax = reservationOrderDetails.reduce((sum: number, detail: any) => sum + (detail.tax || 0), 0);
						const grandTotal = reservationOrderDetails.reduce((sum: number, detail: any) => sum + (detail.total || 0), 0);

						const reservationPaymentsReceived = reservationPayments
							.filter((p: any) => p && p.type === 2)
							.reduce((sum: number, payment: any) => {
								const amount = payment.amount || 0;
								return sum + amount;
							}, 0);

						let outstandingBalance = grandTotal + reservationPaymentsReceived;
						if (outstandingBalance < 0) {
							outstandingBalance = 0;
						}

						doc.setFillColor(255, 255, 255);
						doc.rect(0, 0, pageWidth, 80, 'F');

						const logoHeight = 40;
						const logoWidth = (logoHeight * 6);
						const logoX = margin;
						const logoY = 20;

						try {
							doc.addImage(logoData, 'PNG', logoX, logoY, logoWidth, logoHeight);
						} catch (error) {
							console.log('Logo image failed to load');
						}

					doc.setTextColor(6, 70, 91);
						doc.setFontSize(32);
						doc.setFont('helvetica', 'bold');
						const invoiceTitle = 'INVOICE';
						const titleWidth = doc.getTextWidth(invoiceTitle);
						doc.text(invoiceTitle, pageWidth - margin - titleWidth, 45);

						const invoiceDate = orderData?.createDate
							? moment(orderData.createDate).format('MMMM DD, YYYY')
							: moment().format('MMMM DD, YYYY');
						const reservationNumber = reservation?.reservationId?.toString() || 'N/A';

						doc.setTextColor(100, 100, 100);
						doc.setFontSize(10);
						doc.setFont('helvetica', 'normal');
						doc.text(`Invoice Date: ${invoiceDate}`, pageWidth - margin - titleWidth, 60);
						doc.text(`Invoice #: ${reservationNumber}`, pageWidth - margin - titleWidth, 72);

						doc.setDrawColor(200, 200, 200);
						doc.setLineWidth(0.5);
						doc.line(margin, 90, pageWidth - margin, 90);

						yPos = 110;

						const checkInDate = reservation?.checkInDate
							? moment(reservation.checkInDate).format('MMMM DD, YYYY')
							: 'N/A';
						const checkOutDate = reservation?.checkOutDate
							? moment(reservation.checkOutDate).format('MMMM DD, YYYY')
							: 'N/A';
						const propertyCode = reservation?.shortTermRental?.propertyCode || 'N/A';

					doc.setTextColor(6, 70, 91);
						doc.setFontSize(11);
						doc.setFont('helvetica', 'bold');
						doc.text('RESERVATION INFORMATION', margin, yPos);
						yPos += 20;

						doc.setTextColor(60, 60, 60);
						doc.setFontSize(10);
						doc.setFont('helvetica', 'normal');
						doc.text(`Reservation #: ${reservationNumber}`, margin, yPos);
						yPos += 16;
						doc.text(`Property: ${propertyCode}`, margin, yPos);
						yPos += 16;
						doc.text(`Check-in: ${checkInDate}`, margin, yPos);
						yPos += 16;
						doc.text(`Check-out: ${checkOutDate}`, margin, yPos);

						const rightColumnX = pageWidth / 2 + 20;
						let guestYPos = yPos - 70;

						const guestProfile = reservation?.guestProfile;
						if (guestProfile) {
							doc.setTextColor(6, 70, 91);
							doc.setFontSize(11);
							doc.setFont('helvetica', 'bold');
							doc.text('GUEST INFORMATION', rightColumnX, guestYPos);
							guestYPos += 20;

							doc.setTextColor(60, 60, 60);
							doc.setFontSize(10);
							doc.setFont('helvetica', 'normal');

							const customerName = `${guestProfile.firstName || ''} ${guestProfile.lastName || ''}`.trim();
							if (customerName) {
								doc.text(customerName, rightColumnX, guestYPos);
								guestYPos += 16;
							}
							if (guestProfile.emailAddress) {
								doc.text(guestProfile.emailAddress, rightColumnX, guestYPos);
								guestYPos += 16;
							}
							if (guestProfile.mobilePhone) {
								doc.text(guestProfile.mobilePhone, rightColumnX, guestYPos);
								guestYPos += 16;
							}

							if (guestProfile.adrStreet) {
								doc.text(guestProfile.adrStreet, rightColumnX, guestYPos);
								guestYPos += 16;
							}

							const addressParts = [];
							if (guestProfile.adrCity) addressParts.push(guestProfile.adrCity);
							if (guestProfile.adrState) addressParts.push(guestProfile.adrState);
							if (guestProfile.adrPostalCode) addressParts.push(guestProfile.adrPostalCode);

							if (addressParts.length > 0) {
								doc.text(addressParts.join(', '), rightColumnX, guestYPos);
								guestYPos += 16;
							}

							if (guestProfile.adrCountry) {
								let countryName = guestProfile.adrCountry;
								if (this.countries && Array.isArray(this.countries)) {
									const country = this.countries.find((c: any) =>
										c.abbr === guestProfile.adrCountry ||
										c.value === guestProfile.adrCountry ||
										c.name === guestProfile.adrCountry
									);
									if (country) {
										countryName = country.name || countryName;
									}
								}
								doc.text(countryName, rightColumnX, guestYPos);
							}
						}

						yPos = Math.max(yPos, guestYPos) + 25;

						doc.setDrawColor(200, 200, 200);
						doc.setLineWidth(0.5);
						doc.line(margin, yPos - 10, pageWidth - margin, yPos - 10);
						yPos += 5;

						const itemDate = orderData?.createDate
							? moment(orderData.createDate).format('MM/DD/YYYY')
							: 'N/A';

						const tableData = reservationOrderDetails.map((detail: any) => {
							const discount = detail.listPriceAdjustmentAmount || 0;
							return [
								detail.name || 'N/A',
								itemDate,
								detail.quantity || 0,
								`$${numberFormatter.format(detail.listPrice || 0)}`,
								discount !== 0 ? `$${numberFormatter.format(Math.abs(discount))}` : '$0.00',
								`$${numberFormatter.format(detail.subTotal || 0)}`,
								`$${numberFormatter.format(detail.tax || 0)}`,
								`$${numberFormatter.format(detail.total || 0)}`
							];
						});

					const availableWidth = pageWidth - (2 * margin);

					const originalWidths = [120, 70, 30, 60, 55, 60, 50, 60];
					const totalOriginalWidth = originalWidths.reduce((sum, w) => sum + w, 0);

					const scaledWidths = originalWidths.map(w => (w / totalOriginalWidth) * availableWidth);

					(doc as any).autoTable({
						startY: yPos,
						head: [['Description', 'Date Added', 'Qty', 'Unit Price', 'Discount', 'Subtotal', 'Tax', 'Total']],
						body: tableData,
						theme: 'striped',
						headStyles: {
							fillColor: [6, 70, 91],
							textColor: 255,
							fontStyle: 'bold',
							fontSize: 10,
							halign: 'right'
						},
						styles: {
							fontSize: 9,
							textColor: [60, 60, 60],
							cellPadding: 4
						},
						alternateRowStyles: {
							fillColor: [250, 250, 250]
						},
						margin: { left: margin, right: margin },
						columnStyles: {
							0: { cellWidth: scaledWidths[0], halign: 'left' }, // Description
							1: { cellWidth: scaledWidths[1], halign: 'right' }, // Date
							2: { cellWidth: scaledWidths[2], halign: 'right' }, // Qty
							3: { cellWidth: scaledWidths[3], halign: 'right' }, // Unit Price
							4: { cellWidth: scaledWidths[4], halign: 'right' }, // Discount
							5: { cellWidth: scaledWidths[5], halign: 'right' }, // Subtotal
							6: { cellWidth: scaledWidths[6], halign: 'right' }, // Tax
							7: { cellWidth: scaledWidths[7], halign: 'right' } // Total
						}
					});

						const finalY = (doc as any).lastAutoTable.finalY + 15;

						const totalsStartX = pageWidth - margin - 280;
						const totalsLabelX = totalsStartX;
						const totalsValueX = pageWidth - margin;
						let currentY = finalY;

						// doc.setDrawColor(200, 200, 200);
						// doc.setLineWidth(0.5);
						// doc.line(totalsStartX, currentY, pageWidth - margin, currentY);
						// currentY += 15;

						doc.setFont('helvetica', 'bold');
						doc.setFontSize(10);
						doc.setTextColor(60, 60, 60);
						doc.text('Total Amount', totalsLabelX, currentY);
						doc.text(`$${numberFormatter.format(subTotal)}`, totalsValueX, currentY, { align: 'right' });
						currentY += 18;


						doc.text('Total Tax', totalsLabelX, currentY);
						doc.text(`$${numberFormatter.format(totalTax)}`, totalsValueX, currentY, { align: 'right' });
						currentY += 18;

						// doc.setDrawColor(200, 200, 200);
						// doc.setLineWidth(0.5);
						// doc.line(totalsStartX, currentY, pageWidth - margin, currentY);
						// currentY += 15;

					// Grand Total - emphasized
					// doc.setFont('helvetica', 'bold');
					// doc.setFontSize(12);
					// doc.setTextColor(6, 70, 91);
						doc.text('Grand Total', totalsLabelX, currentY);
						doc.text(`$${numberFormatter.format(grandTotal)}`, totalsValueX, currentY, { align: 'right' });
						currentY += 25;

						if (reservationPayments.length > 0) {
							const paymentEntries = reservationPayments.filter((payment: any) => payment.type === 2 && payment.description && payment.amount);
							if (paymentEntries.length > 0) {
								doc.setFont('helvetica', 'bold');
								doc.setFontSize(10);
								doc.setTextColor(6, 70, 91);
								doc.text('PAYMENTS RECEIVED', totalsLabelX, currentY);
								currentY += 18;

								doc.setFont('helvetica', 'normal');
								doc.setFontSize(10);
								doc.setTextColor(60, 60, 60);

								paymentEntries.forEach((payment: any) => {
									const paymentDate = payment.createDate
										? moment(payment.createDate).format('MM/DD/YYYY')
										: '';
									const paymentDesc = paymentDate ? `${payment.description} (${paymentDate})` : payment.description;
									doc.text(paymentDesc, totalsLabelX - 150, currentY);
									doc.setTextColor(0, 128, 0);
									doc.text(`-$${numberFormatter.format(Math.abs(payment.amount))}`, totalsValueX, currentY, { align: 'right' });
									doc.setTextColor(60, 60, 60);
									currentY += 16;
								});
								currentY += 10;
							} else {
								const totalPaymentsReceived = reservationPayments
									.filter((p: any) => p.type === 2)
									.reduce((sum: number, p: any) => sum + Math.abs(p.amount || 0), 0);
								if (totalPaymentsReceived > 0) {
									const paymentDate = reservationPayments[0]?.createDate
										? moment(reservationPayments[0].createDate).format('MM/DD/YYYY')
										: moment().format('MM/DD/YYYY');
									doc.setFont('helvetica', 'bold');
									doc.setFontSize(10);
									doc.setTextColor(6, 70, 91);
									doc.text('PAYMENTS RECEIVED', totalsLabelX, currentY);
									currentY += 18;
									doc.setFont('helvetica', 'normal');
									doc.setFontSize(10);
									doc.setTextColor(60, 60, 60);
									doc.text(`Total payments as of ${paymentDate}`, totalsLabelX - 150, currentY);
									doc.setTextColor(0, 128, 0);
									doc.text(`-$${numberFormatter.format(totalPaymentsReceived)}`, totalsValueX, currentY, { align: 'right' });
									doc.setTextColor(60, 60, 60);
									currentY += 20;
								}
							}
						}

					if (outstandingBalance > 0) {
						const boxY = currentY - 5;
						const boxHeight = 30;
						const boxStartX = totalsStartX - 5;
						const boxWidth = (pageWidth - margin) - boxStartX;
						doc.setDrawColor(6, 70, 91);
						doc.setLineWidth(1);
						doc.setFillColor(240, 248, 250);
						doc.roundedRect(boxStartX, boxY, boxWidth, boxHeight, 3, 3, 'FD');

						const boxCenterY = boxY + (boxHeight / 2);
						const textY = boxCenterY + 3;

						doc.setFont('helvetica', 'bold');
						doc.setFontSize(11);
						doc.setTextColor(6, 70, 91);
						doc.text('Outstanding Balance', totalsLabelX, textY);
						doc.setFontSize(13);
						doc.text(`$${numberFormatter.format(outstandingBalance)}`, totalsValueX - 10, textY, { align: 'right' });

						currentY = boxY + boxHeight + 10;
						} else {
							doc.setFont('helvetica', 'bold');
							doc.setFontSize(11);
							doc.setTextColor(0, 128, 0);
							doc.text('Balance Paid in Full', totalsLabelX, currentY);
							doc.text(`$${numberFormatter.format(outstandingBalance)}`, totalsValueX, currentY, { align: 'right' });
						}
					};

					const doc = new jsPDF('p', 'pt', 'letter');

					if (hasMultipleReservations) {
						reservations.forEach((reservation: any, index: number) => {
							generateInvoiceForReservation(doc, reservation, index === 0, logoDataUrl);
						});
					} else {
						const reservation = reservations[0] || this.reservation;
						generateInvoiceForReservation(doc, reservation, true, logoDataUrl);
					}

						const reservation = reservations[0] || this.reservation;
						const reservationNumber = reservation?.reservationId?.toString() || 'N/A';
						const fileName = hasMultipleReservations
							? `Invoice_Multiple_${moment().format('YYYY-MM-DD')}.pdf`
							: `Invoice_${reservationNumber}_${moment().format('YYYY-MM-DD')}.pdf`;

						resolve({ doc, fileName });
					} catch (error) {
						console.error('Error generating PDF:', error);
						reject(error);
					}
				})
				.catch((error) => {
					console.error('Error loading logo image:', error);
					reject(error);
				});
		});
	}

	downloadInvoicePDF() {
		if (!this.reservation && !this.order) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation or Order data not available', life: 3000 });
			return;
		}

		this.formLoading = true;

		this.generateInvoicePDF()
			.then(({ doc, fileName }) => {
				// Generate PDF as blob
				const pdfBlob = doc.output('blob');
				const pdfUrl = URL.createObjectURL(pdfBlob);

				// Create a download link and trigger download
				const downloadLink = document.createElement('a');
				downloadLink.href = pdfUrl;
				downloadLink.download = fileName;
				downloadLink.style.display = 'none';
				document.body.appendChild(downloadLink);
				downloadLink.click();
				document.body.removeChild(downloadLink);

				// Clean up the blob URL
				setTimeout(() => {
					URL.revokeObjectURL(pdfUrl);
				}, 1000);

				this.messageService.add({
					severity: 'success',
					summary: 'Success',
					detail: 'Invoice PDF downloaded successfully',
					life: 2000
				});

				this.formLoading = false;
			})
			.catch((error) => {
				console.error('Error generating PDF:', error);
				this.messageService.add({
					severity: 'error',
					summary: 'Error',
					detail: 'Failed to generate PDF: ' + (error as Error).message,
					life: 5000
				});
				this.formLoading = false;
			});
	}

	printInvoicePDF() {
		if (!this.reservation && !this.order) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation or Order data not available', life: 3000 });
			return;
		}

		this.formLoading = true;

		this.generateInvoicePDF()
			.then(({ doc }) => {
				// Generate PDF as blob
				const pdfBlob = doc.output('blob');
				const pdfUrl = URL.createObjectURL(pdfBlob);

				// Open in new window for printing
				const printWindow = window.open(pdfUrl, '_blank');

				if (printWindow) {
					setTimeout(() => {
						try {
							printWindow.focus();
							setTimeout(() => {
								printWindow.print();
							}, 500);
						} catch (e) {
							console.log('Print dialog may require user interaction');
						}
						// Clean up the blob URL after a delay
						setTimeout(() => {
							URL.revokeObjectURL(pdfUrl);
						}, 5000);
					}, 500);

					this.messageService.add({
						severity: 'success',
						summary: 'Success',
						detail: 'Opening print dialog...',
						life: 2000
					});
				} else {
					URL.revokeObjectURL(pdfUrl);
					this.messageService.add({
						severity: 'warn',
						summary: 'Pop-up Blocked',
						detail: 'Please allow pop-ups to use print dialog.',
						life: 3000
					});
				}

				this.formLoading = false;
			})
			.catch((error) => {
				console.error('Error generating PDF:', error);
				this.messageService.add({
					severity: 'error',
					summary: 'Error',
					detail: 'Failed to generate PDF: ' + (error as Error).message,
					life: 5000
				});
				this.formLoading = false;
			});
	}

	printContractPDF() {
		if (!this.reservation) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation data not available', life: 3000 });
			return;
		}


		// Get reservation number to match in order.reservations
		const reservationNumber = this.reservation?.reservationId;

		// Get contract terms from order.reservations matching the reservationNumber
		let contractTerms: string | null | undefined = null;

		console.log("this.reservation : ", this.order?.reservations, this.reservation,reservationNumber);


		if (this.order?.reservations && reservationNumber) {
			const matchedReservation = this.order.reservations.find(
				(res: any) => res?.reservationId === reservationNumber || res?.reservationId?.toString() === reservationNumber?.toString()
			);

			if (matchedReservation) {
				contractTerms = matchedReservation?.contractTerms || matchedReservation?.shortTermRental?.contractTerms;
			}
		}

		// Fallback to current reservation if not found in order.reservations
		if (!contractTerms) {
			contractTerms = this.reservation?.contractTerms || this.reservation?.shortTermRental?.contractTerms;
		}

		if (!contractTerms) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Contract terms not available', life: 3000 });
			return;
		}

	this.formLoading = true;

	const loadImageAsDataUrl = (src: string): Promise<string> => {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.crossOrigin = 'anonymous';
			img.onload = () => {
				const canvas = document.createElement('canvas');
				canvas.width = img.width;
				canvas.height = img.height;
				const ctx = canvas.getContext('2d');
				if (ctx) {
					ctx.drawImage(img, 0, 0);
					resolve(canvas.toDataURL('image/png'));
				} else {
					reject(new Error('Could not get canvas context'));
				}
			};
			img.onerror = reject;
			img.src = src;
		});
	};

	loadImageAsDataUrl('/assets/img/header-logo.png')
		.then((logoDataUrl: string) => {
			try {
				const doc = new jsPDF('p', 'pt', 'letter');
				const pageWidth = doc.internal.pageSize.getWidth();
				const pageHeight = doc.internal.pageSize.getHeight();
				const margin = 20;
				let yPos = margin;

				doc.setFillColor(255, 255, 255);
				doc.rect(0, 0, pageWidth, 60, 'F');

				const logoHeight = 35;
				const logoWidth = (logoHeight * 6);
				const logoX = margin;
				const logoY = (60 - logoHeight) / 2;

				try {
					doc.addImage(logoDataUrl, 'PNG', logoX, logoY, logoWidth, logoHeight);
				} catch (error) {
					doc.setTextColor(255, 255, 255);
					doc.setFontSize(24);
					doc.setFont('helvetica', 'bold');
					doc.text('Contract Terms', margin, 30);
				}

				yPos = 100;

				doc.setTextColor(0, 0, 0);
				doc.setFontSize(12);
				doc.setFont('helvetica', 'bold');

				const reservationNumber = this.reservation?.reservationId?.toString() || 'N/A';
				const checkInDate = this.reservation?.checkInDate
					? moment(this.reservation.checkInDate).format('MM-DD-YYYY')
					: 'N/A';
				const checkOutDate = this.reservation?.checkOutDate
					? moment(this.reservation.checkOutDate).format('MM-DD-YYYY')
					: 'N/A';
				const propertyCode = this.reservation?.shortTermRental?.propertyCode || 'N/A';

				let reservationLine = 'Reservation : ';
				doc.text(reservationLine, margin, yPos);
				let xPos = margin + doc.getTextWidth(reservationLine);

				doc.setFont('helvetica', 'normal');
				doc.text(reservationNumber, xPos, yPos);
				xPos += doc.getTextWidth(reservationNumber) + 15;

				doc.setFont('helvetica', 'bold');
				doc.text('Property: ', xPos, yPos);
				xPos += doc.getTextWidth('Property: ');

				doc.setFont('helvetica', 'normal');
				doc.text(propertyCode, xPos, yPos);
				xPos += doc.getTextWidth(propertyCode) + 15;

				doc.setFont('helvetica', 'bold');
				doc.text('Check-in Date: ', xPos, yPos);
				xPos += doc.getTextWidth('Check-in Date: ');

				doc.setFont('helvetica', 'normal');
				doc.text(checkInDate, xPos, yPos);
				xPos += doc.getTextWidth(checkInDate) + 15;

				doc.setFont('helvetica', 'bold');
				doc.text('Check-out Date: ', xPos, yPos);
				xPos += doc.getTextWidth('Check-out Date: ');

				doc.setFont('helvetica', 'normal');
				doc.text(checkOutDate, xPos, yPos);

				yPos += 30;

				doc.setFont('helvetica', 'normal');
				doc.setFontSize(10);

				const maxWidth = pageWidth - (margin * 2);
				const lines = doc.splitTextToSize(contractTerms, maxWidth);

				lines.forEach((line: string) => {
					if (yPos > pageHeight - margin - 20) {
						doc.addPage();
						yPos = margin;
					}
					doc.text(line, margin, yPos);
					yPos += 15;
				});

				const pdfBlob = doc.output('blob');
				const pdfUrl = URL.createObjectURL(pdfBlob);

				const printWindow = window.open(pdfUrl, '_blank');

				if (printWindow) {
					setTimeout(() => {
						try {
							printWindow.focus();
							setTimeout(() => {
								printWindow.print();
							}, 500);
						} catch (e) {
							console.log('Print dialog may require user interaction');
						}
						setTimeout(() => {
							URL.revokeObjectURL(pdfUrl);
						}, 2000);
					}, 500);

					this.messageService.add({
						severity: 'success',
						summary: 'Success',
						detail: 'Opening print dialog...',
						life: 2000
					});
				} else {
					URL.revokeObjectURL(pdfUrl);
					const fileName = `Contract_${reservationNumber}_${moment().format('YYYY-MM-DD')}.pdf`;
					doc.save(fileName);
					this.messageService.add({
						severity: 'warn',
						summary: 'Pop-up Blocked',
						detail: 'PDF downloaded instead. Please allow pop-ups to use print dialog.',
						life: 3000
					});
				}
			} catch (error) {
				console.error('Error generating contract PDF:', error);
				this.messageService.add({
					severity: 'error',
					summary: 'Error',
					detail: 'Failed to generate contract PDF: ' + (error as Error).message,
					life: 5000
				});
			} finally {
				this.formLoading = false;
			}
		})
		.catch((error) => {
			console.error('Error loading logo:', error);
			this.messageService.add({
				severity: 'error',
				summary: 'Error',
				detail: 'Failed to load logo image',
				life: 3000
			});
			this.formLoading = false;
		});
	}

	/**
	 *
	 *
	 * GUEST COMPANION FORM
	 *
	 *
	 */
	get guestCompanions(): FormArray {
		return this.form1.get('guestProfile')?.get('guestCompanions') as FormArray
	}

	newCompanion(): FormGroup {
		// check testmod is true or false
		// if (this.isTestMode) {
		// 	// if testmode is true at that time set this build form
		// 	return this._formBuilder.group({
		// 		firstName: Math.random().toString(36).substring(2, 7),
		// 		lastName: Math.random().toString(36).substring(2, 7),
		// 		birthDate: new Date(+(new Date()) - Math.floor(Math.random() * 10000000000)),
		// 		ageType: ''
		// 	})
		// }
		// if not testmode at that time set this build form
		if (this.guestCompanions.length < (this.reservation?.numAdults) - 1) {
			return this.formBuilder.group({
				firstName: [''],
				lastName: [''],
				birthDate: [''],
				ageType: ['adult'],
				guestCompanionId: [''],
				guestProfileId: [this.reservation?.guestProfile?.guestProfileId]
			})
		} else {
			return this.formBuilder.group({
				firstName: [''],
				lastName: [''],
				birthDate: [''],
				ageType: ['child'],
				guestCompanionId: [''],
				guestProfileId: [this.reservation?.guestProfile?.guestProfileId]
			})
		}
	}

	mapCompanion(campanion: any): FormGroup {
		return this.formBuilder.group({
			firstName: campanion?.firstName,
			lastName: campanion?.lastName,
			birthDate: campanion?.birthDate != null ? moment(campanion?.birthDate).toDate() : "",
			ageType: campanion?.ageType,
			guestCompanionId: campanion?.guestCompanionId,
			guestProfileId: this.reservation?.guestProfile?.guestProfileId
		})
	}

	// this methos use for add companions
	addCompanion() {
		if (this.guestCompanions.length < ((this.reservation?.numAdults + this.reservation?.numChildren) - 1)) {
			this.guestCompanions.push(this.newCompanion());
		}
	}

	// use for delete campanion
	deleteCompanion(i: number) {
		this.guestCompanions.removeAt(i);
		this.updateReservation();
	}

	// showDialog() {
	// 	this.form2.reset();
	// 	this.cdr.detectChanges();
	// 	this.visible = true;
	// }

	// makeAdditionalPayment() {
	// 	try {
	// 		// stop here if form is invalid
	// 		this.form2.markAllAsTouched();
	// 		if(this.form2.value.paymentSource.iAgree == "" || this.form2.value.paymentSource.iAgree == null || this.form2.value.paymentSource.iAgree == false || this.form2.value.paymentSource.iAgree == undefined){
	// 			this.isGuestAgreeForCreditCard = true;
	// 			this.disabledBookReservationButton = false;
	// 			return;
	// 		}else{
	// 			this.isGuestAgreeForCreditCard = false;
	// 			// this.form2.value.paymentSource.iAgree == "Yes"
	// 		}
	// 		if (this.form2.invalid) {
	// 			this.disabledBookReservationButton = false;
	// 			return;
	// 		}

	// 		this.formLoading = true;
	// 		// set contract data into form contract
	// 		// this.form1.value.contract.signBase64 = this.signBase64;
	// 		console.log("this.form1.value this.form1.value " + JSON.stringify(this.form2.value));
	// 		const paymentData = {
	// 			"reservationId": this.reservation.reservationId,
	// 			"orderId": this.reservation?.order?.orderId,
	// 			"paymentSource": {
	// 				"firstName": this.reservation?.guestProfile?.firstName,
	// 				"lastName": this.reservation?.guestProfile?.lastName,
	// 				"paymentAmount": this.form2.value?.paymentSource?.paymentAmount.replace(/[\$,]/g, ''),
	// 				"cardNumber": this.form2.value?.paymentSource?.cardNumber,
	// 				"cardSecurityCode": this.form2.value?.paymentSource?.cardSecurityCode != null ? this.form2.value?.paymentSource?.cardSecurityCode.toString() : '',
	// 				"cardExpirationYear": this.form2.value?.paymentSource?.cardExpirationYear,
	// 				"cardExpirationMonth": this.form2.value?.paymentSource?.cardExpirationMonth,
	// 				"stateOrProvince": this.reservation?.guestProfile?.adrState,
	// 				"postalCode": this.form2.value?.paymentSource?.postalCode,
	// 				"zip": this.form2.value?.paymentSource?.postalCode,
	// 				"city": this.reservation?.guestProfile?.adrCity,
	// 				"countryName": this.reservation?.guestProfile?.adrCountry,
	// 				"stateName": this.reservation?.guestProfile?.adrState,
	// 				"email": this.reservation?.guestProfile?.emailAddress,
	// 				"phone": this.reservation?.guestProfile?.mobilePhone,
	// 				"addressLine1": this.reservation?.guestProfile?.adrStreet,
	// 				"paymentTypeId": 1,
	// 				"cardName": this.form2.value?.paymentSource?.cardName,
	// 				"creditCardTypeId": 1,
	// 				"paymentDescription": "XXX",
	// 				"cardType": "VISA",
	// 				"country": "US",
	// 				"paymentType": "CR",
	// 				"iAgree": this.form2.value.paymentSource.iAgree == true ? "Yes" : "No",
	// 				"paymentSourceId": this.form2.value.paymentSource?.paymentSourceId,
	// 				"transactionType": this.form2.value.paymentSource?.paymentCreditCardRequestedTransactionType,
	// 			},
	// 			"contract": {
	// 				"signName": "KBm KBmresorts null",
	// 				"signEmail": "dev@kbmresorts.cpm"
	// 			},
	// 		}
	// 		// call api related create booking
	// 		this.reservationService.makeAdditionalPaymentByAdmin(paymentData)
	// 			.subscribe(
	// 				(res: any) => {
	// 					this.formLoading = false;
	// 					this.visible = false;
	// 					if(res.data?.reservationSummary?.reservationApiList[0]?.status == "INVALID"){
	// 						this.confirmationService.confirm({
	// 							header: 'Payment Error',
	// 							message: res.data?.reservationSummary?.reservationApiList[0]?.errors[0]?.message,
	// 							icon: 'fa fa-exclamation-triangle',
	// 							rejectVisible: false,
	// 							acceptLabel: 'Close',
	// 							accept: () => {
	// 								//Actual logic to perform a confirmation
	// 								this.disabledBookReservationButton = false;
	// 								this.formLoading = false;
	// 							}
	// 						});
	// 					}else{
	// 						this.showPaymentSuccess = true;
	// 					}
	// 				},
	// 				(err: any) => {
	// 					this.disabledBookReservationButton = false;
	// 					this.formLoading = false;
	// 					this.confirmationService.confirm({
	// 						header: 'Payment Error',
	// 						message: err,
	// 						icon: 'fa fa-exclamation-triangle',
	// 						rejectVisible: false,
	// 						acceptLabel: 'Close',
	// 						accept: () => {
	// 							//Actual logic to perform a confirmation
	// 						}
	// 					});

	// 					console.log('property-add FAIL: ' + JSON.stringify(err));
	// 				},
	// 				() => { });
	// 	} catch (error) {
	// 		this.formLoading = false;
	// 	}
	// }

	//Close open dialog box
	closePaymentDialog() {
		this.showPaymentSuccess = false;
		window.location.reload();
	}

	// Checked mark i agree button
	checkedIAgree(event: any, validationName: any) {
		// clear signature pad

		// Set toggle like I agree by user checked or not
		// this.isGuestAgreeForCreditCard = event.target.checked;
		console.log("gggggg :" + event.target.checked);
		this.form2.value.paymentSource.iAgree = event.target.checked;
		if (event.target.checked) {
			this.isGuestAgreeForCreditCard = false;
			console.log("yyyyyyy :" + event.target.checked);
			// if (validationName == "iAgree" && this.errorList.indexOf(this.guestContractApproveMsg) !== -1) {
			// 	this.updateValidation(this.guestContractApproveMsg);
			// }
		} else {
			this.isGuestAgreeForCreditCard = true;
			// this.errorList.push(this.guestContractApproveMsg);
			// this.errorMessages = "";
			// for (let i = 0; i < this.errorList.length; i++) {
			// 	this.errorMessages += this.errorList[i] + "<br>";
			// }
		}

	}

	selectPaymentSource(event: any) {
		if (event?.value) {
			const paymentSource = this.paymentSources.find((e: any) => e.value == event.value);
			this.form2.get('paymentSource')?.get('cardName').setValue(paymentSource?.paymentSource?.billingName);
			this.form2.get('paymentSource')?.get('cardExpirationMonth').setValue(paymentSource?.paymentSource?.creditCardExpirationMonth);
			this.form2.get('paymentSource')?.get('cardExpirationYear').setValue(paymentSource?.paymentSource?.creditCardExpirationYear);
			this.form2.get('paymentSource')?.get('cardNumber').setValue(paymentSource?.paymentSource?.creditCardNumber);
			if (paymentSource?.paymentSource?.creditCardSecurityCode != null && paymentSource?.paymentSource?.creditCardSecurityCode != undefined && paymentSource?.paymentSource?.creditCardSecurityCode != "") {
				this.form2.get('paymentSource')?.get('cardSecurityCode').setValue(paymentSource?.paymentSource?.creditCardSecurityCode.toString());
			}
			this.form2.get('paymentSource')?.get('postalCode').setValue(paymentSource?.paymentSource?.billingPostalCode);
		}
		else {
			return '';
		}
	}


	getWorkOrderStatus(workOrder: any) {
		if (workOrder?.workOrderStatus) {
			const status = this.workOrderStatuses.find((e: any) => e.value == workOrder.workOrderStatus);
			return status.name;
		}
		else {
			return '';
		}
	}

	getReservationStatus(reservationStatus: any) {
		if (reservationStatus) {
			const status = this.reservationStatuses.find((e: any) => e.value == reservationStatus);
			return status.name;
		}
		else {
			return '';
		}
	}

	getReservationType(reservationType: any) {
		if (reservationType) {
			const status = this.reservationTypes.find((e: any) => e.value == reservationType);
			return status.name;
		}
		else {
			return '';
		}
	}

	getWorkOrderType(workOrder: any) {
		if (workOrder?.housekeepingType) {
			const status = this.housekeepingTypes.find((e: any) => e.value == workOrder.housekeepingType);
			return status.name;
		}
		else {
			return '';
		}
	}

	//Update tag list in reservation to show in colored tags list
	updateTagModified(event) {
		this.reservation.tagJoinAPIS = event;
	}

	filterText(text: string) {
		if (text) {
			text = text
				.replace('<br>', '\r')
				.replace('/&lt;br/&gt;', '\r')
				.replace('</p>', '')
				.replace('<br>', '\r')
			// .replace(/(?:\r\n|\r|\n|\\r|\\n)/gi, '<br>');
			return text;
		}
		return '';
	}


	// Update CheckInCheckOut method
	updateCheckInCheckOut() {
		const formData = JSON.parse(JSON.stringify(this.form1.value));
		if (formData.checkInDate != "undefined" && formData.checkInDate != null) {
			if (formData.checkInDate.includes("T")) {
				formData.checkInDate = moment(formData.checkInDate).format("YYYY-MM-DD");
			} else {
				var splitDateOfCheckInDate = formData.checkInDate.split('/');
				if (splitDateOfCheckInDate[0].length == 2) {
					var monthOfCheckInDate = splitDateOfCheckInDate[0];
					var dayOfCheckInDate = splitDateOfCheckInDate[1];
					var yearOfCheckInDate = splitDateOfCheckInDate[2];
					formData.checkInDate = yearOfCheckInDate + "-" + monthOfCheckInDate + "-" + dayOfCheckInDate;
				}
				if (splitDateOfCheckInDate[0].length == 4) {
					var yearOfCheckInDate = splitDateOfCheckInDate[0];
					var monthOfCheckInDate = splitDateOfCheckInDate[1];
					var dayOfCheckInDate = splitDateOfCheckInDate[2];
					formData.checkInDate = yearOfCheckInDate + "-" + monthOfCheckInDate + "-" + dayOfCheckInDate;
				}
			}
		} else {
			formData.checkInDate = '';
		}
		if (formData.checkOutDate != "undefined" && formData.checkOutDate != null) {
			if (formData.checkOutDate.includes("T")) {
				formData.checkOutDate = moment(formData.checkOutDate).format("YYYY-MM-DD");
			} else {
				var splitDateOfCheckOutDate = formData.checkOutDate.split('/');
				if (splitDateOfCheckOutDate[0].length == 2) {
					var monthOfCheckOutDate = splitDateOfCheckOutDate[0];
					var dayOfCheckOutDate = splitDateOfCheckOutDate[1];
					var yearOfCheckOutDate = splitDateOfCheckOutDate[2];
					formData.checkOutDate = yearOfCheckOutDate + "-" + monthOfCheckOutDate + "-" + dayOfCheckOutDate;
				}
				if (splitDateOfCheckOutDate[0].length == 4) {
					var yearOfCheckOutDate = splitDateOfCheckOutDate[0];
					var monthOfCheckOutDate = splitDateOfCheckOutDate[1];
					var dayOfCheckOutDate = splitDateOfCheckOutDate[2];
					formData.checkOutDate = yearOfCheckOutDate + "-" + monthOfCheckOutDate + "-" + dayOfCheckOutDate;
				}
			}
		} else {
			formData.checkOutDate = '';
		}
		this.form1.value.checkInDate = formData.checkInDate;
		this.form1.value.checkOutDate = formData.checkOutDate;
		this.updateReservation();
	}


	// if select checkin date at that time checkout date set as null
	onKeyDate(event: any) {
		// event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
		// this.form1.patchValue({
		// 	checkOutDate: ""
		// });
	}

	// if select checkout date at that time check checkin date must be below lessthan one day of selected date
	onKeyDateForCheckOutDate(event: any) {
		event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
		if (this.form1.value.checkInDate) {
			let today = new Date(this.form1.value.checkInDate);
			this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
			this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
		}
	}

	// compare checkin and checkout dates
	compareDate(date: any) {
		this.isDateLessThanCheckinDate = false;
		if (Date.parse(date.target.value) < Date.parse(moment(this.checkOutDateBasedOnCheckinDate).format("MM/DD/YYYY"))) {
			this.isDateLessThanCheckinDate = true;
		}
	}

	// open guest modal
	openGuestModal(e: any) {
		// this.dropdown.show();
	}

	// change checking date
	checkInChange(e: any) {
		let today = new Date(e.valueOf());
		this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
		this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
		this.isDisplayClearDates = true;
		// this.form1.patchValue({
		// 	checkOutDate: ""
		// });
		window.setTimeout(() => {
			this.checkOutDateCalender.inputfieldViewChild.nativeElement.focus();
		}, 1);
	}

	// change checkout date
	checkOutChange(e: any) {
		this.isDisplayClearDates = true;
		this.updateReservation();
		// this.guestDropdownCount.show();
	}

	// For Update only reservation status
	updateReservationStatusAndAdult() {
		// stop here if form is invalid
		this.form1.markAllAsTouched();
		if (this.form1.invalid) {
			return;
		}
		// this.formLoading = true;
		this.reservation.order.status = this.form1.value.status;
		this.reservation.order.referralSourceId = this.form1.value.referralSourceId;
		this.reservation.ruReservationId = this.form1.value.ruReservationId;

		//=============================
		// creditSaleToUserId: [],
		// creditSaleToUser2Id: [],
		// salesTax: [],
		// tax: [] = this.form1.value.
		//=============================
		if (this.form1.value.premium !== "0.0000%") {
			this.reservation.order.orderInvoice.ccPremiumPct = this.form1.value.premium;
		}
		this.reservation.reservationStatus = this.form1.value.reservationStatus;
		this.reservation.reservationType = this.form1.value.reservationType;
		this.reservation.numAdults = this.form1.value.numAdults;
		this.reservation.numChildren = this.form1.value.numChildren;
		if (this.form1.value.airportArrivalDate != undefined && this.form1.value.airportArrivalDate != null && this.form1.value.airportArrivalDate != "") {
			this.reservation.airportArrivalDate = this.addLocalTimeToDateTime(new Date(this.form1.value.airportArrivalDate));
		} else {
			this.reservation.airportArrivalDate = null;
		}
		if (this.form1.value.airportDepartureDate != undefined && this.form1.value.airportDepartureDate != null && this.form1.value.airportDepartureDate != "") {
			this.reservation.airportDepartureDate = this.addLocalTimeToDateTime(new Date(this.form1.value.airportDepartureDate));
		} else {
			this.reservation.airportDepartureDate = null;
		}

		if (this.form1.value.propertyArrivalDate != undefined && this.form1.value.propertyArrivalDate != null && this.form1.value.propertyArrivalDate != "") {
			this.reservation.propertyArrivalDate = this.addLocalTimeToDateTime(new Date(this.form1.value.propertyArrivalDate));
		} else {
			this.reservation.propertyArrivalDate = null;
		}
		if (this.form1.value.propertyDepartureDate != undefined && this.form1.value.propertyDepartureDate != null && this.form1.value.propertyDepartureDate != "") {
			this.reservation.propertyDepartureDate = this.addLocalTimeToDateTime(new Date(this.form1.value.propertyDepartureDate));
		} else {
			this.reservation.propertyDepartureDate = null;
		}


		if (this.form1.value.earlyCheckinDate != undefined && this.form1.value.earlyCheckinDate != null && this.form1.value.earlyCheckinDate != "") {
			this.reservation.earlyCheckinDate = this.addLocalTimeToDateTime(new Date(this.form1.value.earlyCheckinDate));
		} else {
			this.reservation.earlyCheckinDate = null;
		}

		if (this.form1.value.lateCheckoutDate != undefined && this.form1.value.lateCheckoutDate != null && this.form1.value.lateCheckoutDate != "") {
			this.reservation.lateCheckoutDate = this.addLocalTimeToDateTime(new Date(this.form1.value.lateCheckoutDate));
		} else {
			this.reservation.lateCheckoutDate = null;
		}

		//===============================
		// arrivalHour1: [] = this.form1.value.
		// arrivalMinute1: [] = this.form1.value.
		// arrivalAmPm1: [] = this.form1.value.
		//===================================

		this.reservation.arrivingAirlineName = this.form1.value.arrivingAirlineName;
		this.reservation.arrivingAirlineFlightNum = this.form1.value.arrivingAirlineFlightNum;

		//=============================
		// arrivalHour2: [] = this.form1.value.
		// arrivalMinute2: [] = this.form1.value.
		// arrivalAmPm2: [] = this.form1.value.
		//===============================


		this.reservation.departingAirlineName = this.form1.value.departingAirlineName;
		this.reservation.departingAirlineFlightNum = this.form1.value.departingAirlineFlightNum;

		//==============================
		// propertyArrivalHour1: [] = this.form1.value.
		// propertyArrivalMinute1: [] = this.form1.value.
		// propertyArrivalAmPm1: [] = this.form1.value.
		// propertyArrivalHour2: [] = this.form1.value.
		// propertyArrivalMinute2: [] = this.form1.value.
		// propertyArrivalAmPm2: [] = this.form1.value.
		//=======================================

		this.reservation.checkOutDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkOutDate));
		this.reservation.checkInDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkInDate));

		//=====================================
		// specialArrivalHour: [] = this.form1.value.
		// specialArrivalMinute: [] = this.form1.value.
		// specialArrivalAmPm: [] = this.form1.value.
		// specialDepartingHour: [] = this.form1.value.
		// specialDepartingMinute: [] = this.form1.value.
		// specialDepartingAmPm: [] = this.form1.value.
		//====================================

		this.reservation.guestNotes = this.form1.value.guestNotes;
		this.reservation.opsNotes = this.form1.value.opsNotes;
		// lostFoundId: [] = this.form1.value.
		this.reservation.keyServiceType = this.form1.value.keyServiceType;
		this.reservation.codeFrontDoor = this.form1.value.codeFrontDoor;
		this.reservation.codeGarage = this.form1.value.codeGarage;
		this.reservation.towelCode = this.form1.value.towelCode,
			this.reservation.codeGate = this.form1.value.codeGate;
		this.reservation.codeHoaGate = this.form1.value.codeHoaGate;
		this.reservation.rentalCarBudget = this.form1.value.rentalCarBudget;
		this.reservation.rentalCarAvis = this.form1.value.rentalCarAvis;
		this.reservation.codePool = this.form1.value.codePool;
		this.reservation.codeRecreation = this.form1.value.codeRecreation;
		this.reservation.primaryMobilePhone = `${this.form1.value.guestProfile.countryCodeOfPrimaryMobilePhone || ''}${this.form1.value.guestProfile.primaryMobilePhone}`;
		this.reservation.specialRequests = this.form1.value.specialRequests;
		// this.reservation.earlyCheckinDate = this.reservation.earlyCheckinDate;
		// this.reservation.lateCheckoutDate = this.reservation.lateCheckoutDate;

		if (!this.reservation.guestProfile) {
			this.reservation.guestProfile = {
				guestProfileId: null,
				firstName: "",
				lastName: "",
				title: "",
				emailAddress: "",
				mobilePhone: "",
				adrPhone: "",
				adrStreet: "",
				adrCity: "",
				adrState: "",
				adrPostalCode: "",
				adrCountry: "",
				emergencyContactNotes: "",
				travelOccasionNotes: "",
				travelOccasion: "",
				guestCompanions: []
			};
		}


		if (this.reservation?.guestProfile != null && this.reservation?.guestProfile != undefined) {
			this.reservation.guestProfile.firstName = this.form1.value.guestProfile?.firstName || "";
			this.reservation.guestProfile.lastName = this.form1.value.guestProfile?.lastName || "";
			this.reservation.guestProfile.title = this.form1.value.guestProfile?.title || "";
			this.reservation.guestProfile.emailAddress = this.form1.value.guestProfile?.emailAddress || "";
			this.reservation.guestProfile.mobilePhone =
				`${this.form1.value.guestProfile?.countryCodeOfMobilePhone || ''}${this.form1.value.guestProfile?.mobilePhone || ''}`;
			this.reservation.guestProfile.adrPhone = this.form1.value.guestProfile?.adrPhone || "";
			this.reservation.guestProfile.adrStreet = this.form1.value.guestProfile?.adrStreet || "";
			this.reservation.guestProfile.adrCity = this.form1.value.guestProfile?.adrCity || "";
			this.reservation.guestProfile.adrState = this.form1.value.guestProfile?.adrState || "";
			this.reservation.guestProfile.adrPostalCode = this.form1.value.guestProfile?.adrPostalCode || "";
			this.reservation.guestProfile.adrCountry = this.form1.value.guestProfile?.adrCountry || "US";
			this.reservation.guestProfile.emergencyContactNotes = this.form1.value.guestProfile?.emergencyContactNotes || "";
			this.reservation.guestProfile.travelOccasionNotes = this.form1.value.guestProfile?.travelOccasionNotes || "";
			this.reservation.guestProfile.travelOccasion = this.form1.value.guestProfile?.travelOccasion || "";
			this.reservation.guestProfile.guestCompanions = this.form1.value.guestProfile?.guestCompanions || [];
		}
		// if(this.guestCompanions.length > 0){
		// this.reservation.guestProfile.guestCompanions = this.form1.value.guestProfile.guestCompanions;
		// }

		if (this.reservation.order.orderInvoice.paymentSourceDeposit == null || this.reservation.order.orderInvoice.paymentSourceDeposit == undefined) {
			const paymentData = {
				billingName: "",
				billingStreetAddress: "",
				billingCity: "",
				billingState: "",
				billingPostalCode: "",
				billingCountry: "",
				creditCardNumber: "",
				creditCardExpirationMonth: "",
				creditCardExpirationYear: "",
				creditCardSecurityCode: "",
				paymentType: "",
				achBankName: "",
				achBankAccountNumber: "",
				achRoutingNumber: "",
				achCheckNumber: "",
				achMicrData: "",
				achBranchSortCode: "",
			}
			this.reservation.order.orderInvoice.paymentSourceDeposit = paymentData;
		}


		this.reservation.order.orderInvoice.paymentSourceDeposit.billingName = this.form1.value.paymentSourceDeposit.billingName;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingStreetAddress = this.form1.value.paymentSourceDeposit.billingStreetAddress;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingCity = this.form1.value.paymentSourceDeposit.billingCity;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingState = this.form1.value.paymentSourceDeposit.billingState;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingPostalCode = this.form1.value.paymentSourceDeposit.billingPostalCode;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingCountry = this.form1.value.paymentSourceDeposit.billingCountry;
		this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardNumber = this.form1.value.paymentSourceDeposit.creditCardNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationMonth = this.form1.value.paymentSourceDeposit.creditCardExpirationMonth;
		this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationYear = this.form1.value.paymentSourceDeposit.creditCardExpirationYear;
		if (this.form1.value.paymentSourceDeposit.creditCardSecurityCode != null && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != undefined && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != "") {
			this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardSecurityCode = this.form1.value.paymentSourceDeposit.creditCardSecurityCode.toString();
		}
		this.reservation.order.orderInvoice.paymentSourceDeposit.paymentType = this.form1.value.paymentSourceDeposit.paymentType;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achBankName = this.form1.value.paymentSourceDeposit.achBankName;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achBankAccountNumber = this.form1.value.paymentSourceDeposit.achBankAccountNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achRoutingNumber = this.form1.value.paymentSourceDeposit.achRoutingNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achCheckNumber = this.form1.value.paymentSourceDeposit.achCheckNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achMicrData = this.form1.value.paymentSourceDeposit.achMicrData;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achBranchSortCode = this.form1.value.paymentSourceDeposit.achBranchSortCode;


		if (this.reservation.order.orderInvoice.paymentSourceFunding == null || this.reservation.order.orderInvoice.paymentSourceFunding == undefined) {
			const paymentData = {
				billingName: "",
				billingStreetAddress: "",
				billingCity: "",
				billingState: "",
				billingPostalCode: "",
				billingCountry: "",
				creditCardNumber: "",
				creditCardExpirationMonth: "",
				creditCardExpirationYear: "",
				creditCardSecurityCode: "",
				paymentType: "",
				achBankName: "",
				achBankAccountNumber: "",
				achRoutingNumber: "",
				achCheckNumber: "",
				achMicrData: "",
				achBranchSortCode: "",
			}
			this.reservation.order.orderInvoice.paymentSourceFunding = paymentData;
		}

		this.reservation.order.orderInvoice.paymentSourceFunding.billingName = this.form1.value.paymentSourceFunding.billingName;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingStreetAddress = this.form1.value.paymentSourceFunding.billingStreetAddress;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingCity = this.form1.value.paymentSourceFunding.billingCity;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingState = this.form1.value.paymentSourceFunding.billingState;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingPostalCode = this.form1.value.paymentSourceFunding.billingPostalCode;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingCountry = this.form1.value.paymentSourceFunding.billingCountry;
		this.reservation.order.orderInvoice.paymentSourceFunding.creditCardNumber = this.form1.value.paymentSourceFunding.creditCardNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationMonth = this.form1.value.paymentSourceFunding.creditCardExpirationMonth;
		this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationYear = this.form1.value.paymentSourceFunding.creditCardExpirationYear;
		if (this.form1.value.paymentSourceFunding.creditCardSecurityCode != null && this.form1.value.paymentSourceFunding.creditCardSecurityCode != undefined && this.form1.value.paymentSourceFunding.creditCardSecurityCode != "") {
			this.reservation.order.orderInvoice.paymentSourceFunding.creditCardSecurityCode = this.form1.value.paymentSourceFunding.creditCardSecurityCode.toString();
		}
		this.reservation.order.orderInvoice.paymentSourceFunding.paymentType = this.form1.value.paymentSourceFunding.paymentType;
		this.reservation.order.orderInvoice.paymentSourceFunding.achBankName = this.form1.value.paymentSourceFunding.achBankName;
		this.reservation.order.orderInvoice.paymentSourceFunding.achBankAccountNumber = this.form1.value.paymentSourceFunding.achBankAccountNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.achRoutingNumber = this.form1.value.paymentSourceFunding.achRoutingNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.achCheckNumber = this.form1.value.paymentSourceFunding.achCheckNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.achMicrData = this.form1.value.paymentSourceFunding.achMicrData;
		this.reservation.order.orderInvoice.paymentSourceFunding.achBranchSortCode = this.form1.value.paymentSourceFunding.achBranchSortCode;
		this.reservation.reservationDirty = true;
		this.getReservations.emit(this.reservation);
		// this.alertService.error('Please enter a title first before entering any other fields.');
		this.formLoading = true;
		this.reservationService.updateGuestInfo(this.reservation)
			.pipe(first())
			.subscribe(
				res => {
					this.formLoading = false;
					console.log('findReservationById: ' + JSON.stringify(res));
					this.alertService.success("Reservation update successfully", true);
					// this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Update reservation successfully', life: 1000 });
					// this.reservation = res.data.reservation;
					this.findReservationById();
				},
				err => {
					// Do NOT reset formLoading on error — a 504 means the backend may
					// have already saved the update. Keep button disabled to block re-submit.
					this.alertService.error(err, true);
					console.log('error reservation update: ' + JSON.stringify(err));
					// this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation update fail: ' + err, sticky: true });
				},
				() => { });
	}

	// Update adult and children
	updateReservationAdultAndChildren() {
		// stop here if form is invalid
		this.form1.markAllAsTouched();
		if (this.form1.invalid) {
			return;
		}
		// this.formLoading = true;
		this.reservation.order.status = this.form1.value.status;
		this.reservation.order.referralSourceId = this.form1.value.referralSourceId;
		this.reservation.ruReservationId = this.form1.value.ruReservationId;

		//=============================
		// creditSaleToUserId: [],
		// creditSaleToUser2Id: [],
		// salesTax: [],
		// tax: [] = this.form1.value.
		//=============================
		if (this.form1.value.premium !== "0.0000%") {
			this.reservation.order.orderInvoice.ccPremiumPct = this.form1.value.premium;
		}
		this.reservation.reservationStatus = this.form1.value.reservationStatus;
		this.reservation.numAdults = this.form1.value.numAdults;
		this.reservation.numChildren = this.form1.value.numChildren;
		if (this.form1.value.airportArrivalDate != undefined && this.form1.value.airportArrivalDate != null && this.form1.value.airportArrivalDate != "") {
			this.reservation.airportArrivalDate = this.addLocalTimeToDateTime(new Date(this.form1.value.airportArrivalDate));
		} else {
			this.reservation.airportArrivalDate = null;
		}
		if (this.form1.value.airportDepartureDate != undefined && this.form1.value.airportDepartureDate != null && this.form1.value.airportDepartureDate != "") {
			this.reservation.airportDepartureDate = this.addLocalTimeToDateTime(new Date(this.form1.value.airportDepartureDate));
		} else {
			this.reservation.airportDepartureDate = null;
		}

		if (this.form1.value.propertyArrivalDate != undefined && this.form1.value.propertyArrivalDate != null && this.form1.value.propertyArrivalDate != "") {
			this.reservation.propertyArrivalDate = this.addLocalTimeToDateTime(new Date(this.form1.value.propertyArrivalDate));
		} else {
			this.reservation.propertyArrivalDate = null;
		}
		if (this.form1.value.propertyDepartureDate != undefined && this.form1.value.propertyDepartureDate != null && this.form1.value.propertyDepartureDate != "") {
			this.reservation.propertyDepartureDate = this.addLocalTimeToDateTime(new Date(this.form1.value.propertyDepartureDate));
		} else {
			this.reservation.propertyDepartureDate = null;
		}


		if (this.form1.value.earlyCheckinDate != undefined && this.form1.value.earlyCheckinDate != null && this.form1.value.earlyCheckinDate != "") {
			this.reservation.earlyCheckinDate = this.addLocalTimeToDateTime(new Date(this.form1.value.earlyCheckinDate));
		} else {
			this.reservation.earlyCheckinDate = null;
		}

		if (this.form1.value.lateCheckoutDate != undefined && this.form1.value.lateCheckoutDate != null && this.form1.value.lateCheckoutDate != "") {
			this.reservation.lateCheckoutDate = this.addLocalTimeToDateTime(new Date(this.form1.value.lateCheckoutDate));
		} else {
			this.reservation.lateCheckoutDate = null;
		}

		//===============================
		// arrivalHour1: [] = this.form1.value.
		// arrivalMinute1: [] = this.form1.value.
		// arrivalAmPm1: [] = this.form1.value.
		//===================================

		this.reservation.arrivingAirlineName = this.form1.value.arrivingAirlineName;
		this.reservation.arrivingAirlineFlightNum = this.form1.value.arrivingAirlineFlightNum;

		//=============================
		// arrivalHour2: [] = this.form1.value.
		// arrivalMinute2: [] = this.form1.value.
		// arrivalAmPm2: [] = this.form1.value.
		//===============================


		this.reservation.departingAirlineName = this.form1.value.departingAirlineName;
		this.reservation.departingAirlineFlightNum = this.form1.value.departingAirlineFlightNum;

		//==============================
		// propertyArrivalHour1: [] = this.form1.value.
		// propertyArrivalMinute1: [] = this.form1.value.
		// propertyArrivalAmPm1: [] = this.form1.value.
		// propertyArrivalHour2: [] = this.form1.value.
		// propertyArrivalMinute2: [] = this.form1.value.
		// propertyArrivalAmPm2: [] = this.form1.value.
		//=======================================

		this.reservation.checkOutDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkOutDate));
		this.reservation.checkInDate = this.addLocalTimeToDateTime(new Date(this.form1.value.checkInDate));

		//=====================================
		// specialArrivalHour: [] = this.form1.value.
		// specialArrivalMinute: [] = this.form1.value.
		// specialArrivalAmPm: [] = this.form1.value.
		// specialDepartingHour: [] = this.form1.value.
		// specialDepartingMinute: [] = this.form1.value.
		// specialDepartingAmPm: [] = this.form1.value.
		//====================================

		this.reservation.guestNotes = this.form1.value.guestNotes;
		this.reservation.opsNotes = this.form1.value.opsNotes;
		// lostFoundId: [] = this.form1.value.
		this.reservation.keyServiceType = this.form1.value.keyServiceType;
		this.reservation.codeFrontDoor = this.form1.value.codeFrontDoor;
		this.reservation.codeGarage = this.form1.value.codeGarage;
		this.reservation.towelCode = this.form1.value.towelCode,
			this.reservation.codeGate = this.form1.value.codeGate;
		this.reservation.codeHoaGate = this.form1.value.codeHoaGate;
		this.reservation.rentalCarBudget = this.form1.value.rentalCarBudget;
		this.reservation.rentalCarAvis = this.form1.value.rentalCarAvis;
		this.reservation.codePool = this.form1.value.codePool;
		this.reservation.codeRecreation = this.form1.value.codeRecreation;
		this.reservation.primaryMobilePhone = `${this.form1.value.guestProfile.countryCodeOfPrimaryMobilePhone || ''}${this.form1.value.guestProfile.primaryMobilePhone}`;
		this.reservation.specialRequests = this.form1.value.specialRequests;
		// this.reservation.earlyCheckinDate = this.reservation.earlyCheckinDate;
		// this.reservation.lateCheckoutDate = this.reservation.lateCheckoutDate;

		if (!this.reservation.guestProfile) {
			this.reservation.guestProfile = {
				guestProfileId: null,
				firstName: "",
				lastName: "",
				title: "",
				emailAddress: "",
				mobilePhone: "",
				adrPhone: "",
				adrStreet: "",
				adrCity: "",
				adrState: "",
				adrPostalCode: "",
				adrCountry: "",
				emergencyContactNotes: "",
				travelOccasionNotes: "",
				travelOccasion: "",
				guestCompanions: []
			};
		}


		if (this.reservation?.guestProfile != null && this.reservation?.guestProfile != undefined) {
			this.reservation.guestProfile.firstName = this.form1.value.guestProfile?.firstName || "";
			this.reservation.guestProfile.lastName = this.form1.value.guestProfile?.lastName || "";
			this.reservation.guestProfile.title = this.form1.value.guestProfile?.title || "";
			this.reservation.guestProfile.emailAddress = this.form1.value.guestProfile?.emailAddress || "";
			this.reservation.guestProfile.mobilePhone =
				`${this.form1.value.guestProfile?.countryCodeOfMobilePhone || ''}${this.form1.value.guestProfile?.mobilePhone || ''}`;
			this.reservation.guestProfile.adrPhone = this.form1.value.guestProfile?.adrPhone || "";
			this.reservation.guestProfile.adrStreet = this.form1.value.guestProfile?.adrStreet || "";
			this.reservation.guestProfile.adrCity = this.form1.value.guestProfile?.adrCity || "";
			this.reservation.guestProfile.adrState = this.form1.value.guestProfile?.adrState || "";
			this.reservation.guestProfile.adrPostalCode = this.form1.value.guestProfile?.adrPostalCode || "";
			this.reservation.guestProfile.adrCountry = this.form1.value.guestProfile?.adrCountry || "US";
			this.reservation.guestProfile.emergencyContactNotes = this.form1.value.guestProfile?.emergencyContactNotes || "";
			this.reservation.guestProfile.travelOccasionNotes = this.form1.value.guestProfile?.travelOccasionNotes || "";
			this.reservation.guestProfile.travelOccasion = this.form1.value.guestProfile?.travelOccasion || "";
			this.reservation.guestProfile.guestCompanions = this.form1.value.guestProfile?.guestCompanions || [];
		}
		// if(this.guestCompanions.length > 0){
		// this.reservation.guestProfile.guestCompanions = this.form1.value.guestProfile.guestCompanions;
		// }

		if (this.reservation.order.orderInvoice.paymentSourceDeposit == null || this.reservation.order.orderInvoice.paymentSourceDeposit == undefined) {
			const paymentData = {
				billingName: "",
				billingStreetAddress: "",
				billingCity: "",
				billingState: "",
				billingPostalCode: "",
				billingCountry: "",
				creditCardNumber: "",
				creditCardExpirationMonth: "",
				creditCardExpirationYear: "",
				creditCardSecurityCode: "",
				paymentType: "",
				achBankName: "",
				achBankAccountNumber: "",
				achRoutingNumber: "",
				achCheckNumber: "",
				achMicrData: "",
				achBranchSortCode: "",
			}
			this.reservation.order.orderInvoice.paymentSourceDeposit = paymentData;
		}


		this.reservation.order.orderInvoice.paymentSourceDeposit.billingName = this.form1.value.paymentSourceDeposit.billingName;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingStreetAddress = this.form1.value.paymentSourceDeposit.billingStreetAddress;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingCity = this.form1.value.paymentSourceDeposit.billingCity;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingState = this.form1.value.paymentSourceDeposit.billingState;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingPostalCode = this.form1.value.paymentSourceDeposit.billingPostalCode;
		this.reservation.order.orderInvoice.paymentSourceDeposit.billingCountry = this.form1.value.paymentSourceDeposit.billingCountry;
		this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardNumber = this.form1.value.paymentSourceDeposit.creditCardNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationMonth = this.form1.value.paymentSourceDeposit.creditCardExpirationMonth;
		this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardExpirationYear = this.form1.value.paymentSourceDeposit.creditCardExpirationYear;
		if (this.form1.value.paymentSourceDeposit.creditCardSecurityCode != null && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != undefined && this.form1.value.paymentSourceDeposit.creditCardSecurityCode != "") {
			this.reservation.order.orderInvoice.paymentSourceDeposit.creditCardSecurityCode = this.form1.value.paymentSourceDeposit.creditCardSecurityCode.toString();
		}
		this.reservation.order.orderInvoice.paymentSourceDeposit.paymentType = this.form1.value.paymentSourceDeposit.paymentType;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achBankName = this.form1.value.paymentSourceDeposit.achBankName;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achBankAccountNumber = this.form1.value.paymentSourceDeposit.achBankAccountNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achRoutingNumber = this.form1.value.paymentSourceDeposit.achRoutingNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achCheckNumber = this.form1.value.paymentSourceDeposit.achCheckNumber;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achMicrData = this.form1.value.paymentSourceDeposit.achMicrData;
		this.reservation.order.orderInvoice.paymentSourceDeposit.achBranchSortCode = this.form1.value.paymentSourceDeposit.achBranchSortCode;


		if (this.reservation.order.orderInvoice.paymentSourceFunding == null || this.reservation.order.orderInvoice.paymentSourceFunding == undefined) {
			const paymentData = {
				billingName: "",
				billingStreetAddress: "",
				billingCity: "",
				billingState: "",
				billingPostalCode: "",
				billingCountry: "",
				creditCardNumber: "",
				creditCardExpirationMonth: "",
				creditCardExpirationYear: "",
				creditCardSecurityCode: "",
				paymentType: "",
				achBankName: "",
				achBankAccountNumber: "",
				achRoutingNumber: "",
				achCheckNumber: "",
				achMicrData: "",
				achBranchSortCode: "",
			}
			this.reservation.order.orderInvoice.paymentSourceFunding = paymentData;
		}

		this.reservation.order.orderInvoice.paymentSourceFunding.billingName = this.form1.value.paymentSourceFunding.billingName;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingStreetAddress = this.form1.value.paymentSourceFunding.billingStreetAddress;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingCity = this.form1.value.paymentSourceFunding.billingCity;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingState = this.form1.value.paymentSourceFunding.billingState;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingPostalCode = this.form1.value.paymentSourceFunding.billingPostalCode;
		this.reservation.order.orderInvoice.paymentSourceFunding.billingCountry = this.form1.value.paymentSourceFunding.billingCountry;
		this.reservation.order.orderInvoice.paymentSourceFunding.creditCardNumber = this.form1.value.paymentSourceFunding.creditCardNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationMonth = this.form1.value.paymentSourceFunding.creditCardExpirationMonth;
		this.reservation.order.orderInvoice.paymentSourceFunding.creditCardExpirationYear = this.form1.value.paymentSourceFunding.creditCardExpirationYear;
		if (this.form1.value.paymentSourceFunding.creditCardSecurityCode != null && this.form1.value.paymentSourceFunding.creditCardSecurityCode != undefined && this.form1.value.paymentSourceFunding.creditCardSecurityCode != "") {
			this.reservation.order.orderInvoice.paymentSourceFunding.creditCardSecurityCode = this.form1.value.paymentSourceFunding.creditCardSecurityCode.toString();
		}
		this.reservation.order.orderInvoice.paymentSourceFunding.paymentType = this.form1.value.paymentSourceFunding.paymentType;
		this.reservation.order.orderInvoice.paymentSourceFunding.achBankName = this.form1.value.paymentSourceFunding.achBankName;
		this.reservation.order.orderInvoice.paymentSourceFunding.achBankAccountNumber = this.form1.value.paymentSourceFunding.achBankAccountNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.achRoutingNumber = this.form1.value.paymentSourceFunding.achRoutingNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.achCheckNumber = this.form1.value.paymentSourceFunding.achCheckNumber;
		this.reservation.order.orderInvoice.paymentSourceFunding.achMicrData = this.form1.value.paymentSourceFunding.achMicrData;
		this.reservation.order.orderInvoice.paymentSourceFunding.achBranchSortCode = this.form1.value.paymentSourceFunding.achBranchSortCode;
		this.reservation.reservationDirty = true;
		this.getReservations.emit(this.reservation);
		// this.alertService.error('Please enter a title first before entering any other fields.');
		this.formLoading = true;
		this.reservationService.updateGuestInfoAutoUpdate(this.reservation)
			.pipe(first())
			.subscribe(
				res => {
					this.formLoading = false;
					console.log('findReservationById: ' + JSON.stringify(res));
					this.alertService.success("Reservation update successfully", true);
					// this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Update reservation successfully', life: 1000 });
					// this.reservation = res.data.reservation;
					this.findReservationById();
				},
				err => {
					// Do NOT reset formLoading on error — a 504 means the backend may
					// have already saved the update. Keep button disabled to block re-submit.
					this.alertService.error(err, true);
					console.log('error reservation update: ' + JSON.stringify(err));
					// this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Reservation update fail: ' + err, sticky: true });
				},
				() => { });
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

	doRefreshOrder() {
		this.refreshOrder.emit();
	}

	autoResizeTextArea(textArea: HTMLTextAreaElement): void {
		textArea.style.height = '30px';  // Set default height
		if (textArea.scrollHeight > 30) {  // Only expand if content exceeds 30px
			textArea.style.height = `${textArea.scrollHeight}px`;
		}
	}

	/*********
		  * Edit Button
		  *
		  */
	onOpenAdditionalPaymentPopUp() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "40vw";
		dialogConfig.width = "30vw";
		dialogConfig.disableClose = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Payment',
			reservation: this.reservation,
			paymentSources: this.paymentSources
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(AdditionalPaymentComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	/**
	 * Combined Authorize / Capture popup — admin picks one of:
	 *   • Authorize Only        -> AUTH_ONLY (auth now, capture later)
	 *   • Authorize Capture     -> PRIOR_AUTH_CAPTURE against a selected prior auth
	 * via a radio toggle inside the popup. The popup shows the prior-auth dropdown
	 * only when "Authorize Capture" is chosen.
	 */
	onOpenDeferredCapturePopUp() {
		// Build the prior-auth list once. Tolerant to either nested paymentConfirm
		// or flat fields on the order invoice detail row.
		const allInvoiceDetails: any[] = this.reservation?.order?.orderInvoice?.orderInvoiceDetails || [];
		const priorAuthsRaw = allInvoiceDetails
			.map((d: any) => d?.paymentConfirm || d)
			.filter((pc: any) => pc
				&& (pc.paymentCreditCardRequestedTransactionType === 'AO'
					|| pc.transactionType === 'AO')
				&& (pc.paymentResultIndicator === 'A'
					|| pc.resultIndicator === 'A'));

		// Mirror backend NOT EXISTS guard: an AO row that already has a matching
		// PC row (any result, same transaction id) is "consumed" — don't offer it
		// as a Prior Auth target.
		const capturedTxnIds = new Set<string>(
			allInvoiceDetails
				.map((d: any) => d?.paymentConfirm || d)
				.filter((pc: any) => pc && (pc.paymentCreditCardRequestedTransactionType === 'PC'
					|| pc.transactionType === 'PC'))
				.map((pc: any) => pc.paymentTransactionConfirmNumber || pc.transactionConfirmNumber)
				.filter((id: any) => !!id)
		);

		const priorAuths = priorAuthsRaw
			.map((pc: any) => ({
				value: pc.paymentTransactionConfirmNumber || pc.transactionConfirmNumber,
				name: (pc.paymentTransactionConfirmNumber || pc.transactionConfirmNumber)
					+ ' — $' + (pc.paymentProcessAmount || pc.processAmount || pc.amount || '?')
					+ ' — ' + (pc.createDate || pc.paymentProcessDate || '')
			}))
			.filter((opt: any) => !!opt.value && !capturedTxnIds.has(opt.value));

		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "40vw";
		dialogConfig.width = "30vw";
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			title: 'Authorize / Capture',
			reservation: this.reservation,
			paymentSources: this.paymentSources,
			deferredCapture: true,
			priorAuths: priorAuths
		};
		const dialogRef = this.dialog.open(AdditionalPaymentComponent, dialogConfig);
		dialogRef.componentInstance.doUpdate.subscribe(
			data => { dialogRef.close(); });
	}

	/**
	 * Reconcile Captured popup — counterpart to the per-row button in the Order
	 * page's Payment Attempts table. Lets an admin who just captured an auth at
	 * the Authorize.net dashboard fast-track the DB sync without finding the row
	 * manually or waiting for the hourly auto-reconcile poll.
	 *
	 * Builds the candidate list from the order's existing payment confirms,
	 * filtering to the same two row shapes the backend accepts:
	 *   • AO + A whose txn id has no matching PC row (auth not yet captured on our side)
	 *   • PC + D / PC + E (scheduler attempted, gateway rejected — typical RRC_3_16)
	 * Already-reconciled (PC + A) rows are excluded.
	 */
	onOpenReconcileCapturedPopUp() {
		const allInvoiceDetails: any[] = this.reservation?.order?.orderInvoice?.orderInvoiceDetails || [];

		// Collect every payment-confirm row referenced by an invoice detail. Tolerant
		// to either nested .paymentConfirm or flat fields on the detail row.
		const allPCs: any[] = allInvoiceDetails
			.map((d: any) => d?.paymentConfirm || d?.paymentConfirmVO || d)
			.filter((pc: any) => !!pc && (pc.paymentConfirmId != null));

		// Mirror the backend NOT EXISTS guard from PaymentConfirmDAO.findPendingCaptures:
		// any txn id that already has a matching PC+A row is "consumed" — exclude it
		// from the candidate list so admin can't try to reconcile something that's
		// already done.
		const reconciledTxnIds = new Set<string>(
			allPCs
				.filter((pc: any) => (pc.paymentCreditCardRequestedTransactionType === 'PC'
						|| pc.transactionType === 'PC')
					&& (pc.paymentResultIndicator === 'A' || pc.resultIndicator === 'A'))
				.map((pc: any) => pc.paymentTransactionConfirmNumber || pc.transactionConfirmNumber)
				.filter((id: any) => !!id)
		);

		const candidates = allPCs
			.filter((pc: any) => {
				const type   = pc.paymentCreditCardRequestedTransactionType || pc.transactionType;
				const result = pc.paymentResultIndicator || pc.resultIndicator;
				const txnId  = pc.paymentTransactionConfirmNumber || pc.transactionConfirmNumber;
				if (!txnId) return false;
				if (reconciledTxnIds.has(txnId)) return false;
				if (type === 'AO' && result === 'A') return true;
				if (type === 'PC' && (result === 'D' || result === 'E')) return true;
				return false;
			})
			.map((pc: any) => ({
				paymentConfirmId: pc.paymentConfirmId,
				authnetTxnId:     pc.paymentTransactionConfirmNumber || pc.transactionConfirmNumber,
				amount:           pc.paymentProcessAmount || pc.processAmount || pc.amount,
				createDate:       pc.createDate || pc.paymentProcessDate || '',
				last4:            pc.paymentSourceAccountIdentifier || '',
				type:             pc.paymentCreditCardRequestedTransactionType || pc.transactionType,
				result:           pc.paymentResultIndicator || pc.resultIndicator,
				billingName:      pc.billingName || ''
			}));

		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "50vw";
		dialogConfig.width = "40vw";
		dialogConfig.disableClose = true;
		dialogConfig.data = { candidates };

		const dialogRef = this.dialog.open(ReconcileCapturedPopupComponent, dialogConfig);
		dialogRef.componentInstance.doUpdate.subscribe(
			(_: any) => { dialogRef.close(); });
	}

	clearField(controlName: string): void {
	  this.form1.get?.(controlName)?.setValue('');
	}

	getStatusColor(statusColor: any): string {
		if(this.reservation?.shortTermRental?.listingType == 2) {
			return "green";
		}else{
			const status = this.reservationStatuses.find(s => s.value === statusColor);
			return status ? status.color : '#800000'; // default fallback color
		}
	}

	getStatusFontColor(statusFontColor: any): string {
		if(this.reservation?.shortTermRental?.listingType == 2) {
			return "white";
		}else{
			const status = this.reservationStatuses.find(s => s.value === statusFontColor);
			return status ? status.fontColor : 'white'; // default fallback color
		}
	}

}
